/* ═══════════════════════════════════════════════════════════════════════
   CRÉAPANEL — assets/cp-a11y.js (chargé par snippets/cp-head-extras.liquid,
   fiches produit) — CONFIGURATEUR AU CLAVIER
   Le moteur pose ses commandes en div et en SVG sans tabindex ni rôle : au
   clavier, aucune cote, aucun chant, aucun coin n'était atteignable (WCAG 2.1.1).
   On ne double rien : les commandes EXISTANTES deviennent atteignables, et la
   touche déclenche le même clic (mêmes fenêtres, mêmes règles min/max).
   Cotes de saisie : bouton « Longueur L1 : 2400 mm », Entrée/Espace = clic.
   Chants : case à cocher nommée (aria-checked), Espace/Entrée = clic.
   Coins : bouton transparent posé sur la zone du moteur (rect.hit), qui
     rejoue le clic au même endroit ; même chose pour l'étiquette d'angle.
   Fenêtres (cote, angle, coin) : focus dans le champ ou sur l'option active ;
     Entrée valide, Échap ferme ; le focus revient sur la commande d'origine.
   Après chaque rendu (le moteur recrée tout), le focus revient sur la
     commande équivalente. Ordre de tabulation : cotes, chants, coins, angle.
   Total annoncé aux lecteurs d'écran (aria-live sur #td-prix-total).
   Forme en G : les 8 cotes de saisie portent un nom visible L1…L4 / P1…P4
     (comme en U), .
   Le moteur n'est pas modifié. CSS en px (1 rem = 10 px sur ce thème).
   ═══════════════════════════════════════════════════════════════════════*/
(function () {
  'use strict';

  function getApp() { try { return (typeof App !== 'undefined') ? App : window.App; } catch (e) { return window.App; } }
  /* A-325 (AUDIT Tour 598, lot D13) : la cote P d'une crédence est une hauteur (crédence repérée par cp-modele) */
  function motP() { var A = getApp(); return A && typeof window.CP_estCredence === 'function' && window.CP_estCredence(A) ? 'Hauteur' : 'Profondeur'; }

  /* Noms des chants : une même clé du moteur ne désigne pas le même bord selon la forme
     (en U, « front » et « sides » sont les bouts des jambes). Clés relevées .*/
  var EDGE_NAMES = {
    linear: { front: 'bord avant', back: 'bord arrière, contre le mur', sides: 'côté gauche', right: 'côté droit' },
    angle: { front: 'bord avant du plan principal', back: 'bord arrière du plan principal, contre le mur', sidesBarreH: 'côté libre du plan principal',
      angleReturn: 'bord arrière du retour, contre le mur', angleReturnH: 'côté du plan principal, à l\'angle', angleReturnTop: 'côté du retour, contre le mur du fond',
      sidesJambeVInner: 'bord avant du retour', sidesJambeVBottom: 'côté libre du retour' },   /* R148-b2 : mots de COMMERCIAL (Tours 210 et 211) */
    /* R148-b3 (COMMERCIAL Tour 218 ; AUDIT 23:20) : angleReturnTop, le petit bord du retour posé contre le mur du fond, est un
       « côté » ; angleReturn garde « bord arrière du retour » (deux cases ne portent plus le même nom) */
    /* R148-b3 (AUDIT 23:18 ; règle de COMMERCIAL, Tour 218) : le haut d'une jambe, contre le mur du fond (U_LEGTOP de cp-trace),
       est un « côté » ; le long bord de la jambe contre le mur de côté garde « bord arrière » (sideLeftU, sideRightU) */
    /* lot « pierres » (AUDIT Tour 1224 ; COMMERCIAL, docs\commercial-a431-r224-textes.md) : en fond filant, sideLeftUTop et
       sideRightUTop sont les bouts du fond (relevé case → pièce sur la découpe), plus le haut des jambes */
    'u-shape': { backLeftU: 'côté de la jambe gauche, contre le mur du fond', backMidU: 'bord arrière du fond, contre le mur', backRightU: 'côté de la jambe droite, contre le mur du fond',
      backflol_left: 'côté de la jambe gauche, contre le mur du fond', backflol_right: 'bord arrière du fond, jusqu\'au coin droit',        /*  clés brutes lues*/
      backolfl_left: 'bord arrière du fond, depuis le coin gauche', backolfl_right: 'côté de la jambe droite, contre le mur du fond',
      innerFront: 'bord avant du fond', sideLeftU: 'bord arrière de la jambe gauche, contre le mur', sideLeftUTop: 'côté gauche du fond, contre le mur de gauche', sideLeftUBot: 'bord arrière de la jambe gauche, en bas',
      sideRightU: 'bord arrière de la jambe droite, contre le mur', sideRightUTop: 'côté droit du fond, contre le mur de droite', sideRightUBot: 'bord arrière de la jambe droite, en bas',
      angleReturn: 'bord avant d\'une jambe', front: 'côté libre de la jambe gauche', sides: 'côté libre de la jambe droite' }   /* R148-b2 : mots de COMMERCIAL */
  };
  /* forme en G (clés composées, suffixes _F/_FF selon les jonctions) : mots de la clé traduits */
  var WORDS = { back: 'bord arrière', front: 'bord avant', sides: 'côté', side: 'côté', inner: 'intérieur', angle: 'angle',
    left: 'gauche', right: 'droit', top: 'du haut', bottom: 'du bas', return: 'du retour', mid: 'du milieu' };
  /* Forme en G : nom tiré de la POSITION RÉELLE sur le tracé (pièces data-piece de cp-trace) ; les
     clés du moteur appellent « left » un montant dessiné à droite en G gauche, et
     donnaient des libellés du type « côté droit gauche g l (au milieu au centre) ».*/
  var G_PIECES = { gauche: 'montant gauche', droite: 'montant droit', haut: 'plan du haut', retour: 'retour' };
  /* champs de la fenêtre d'un coin (moteur, showEdgePopup) */
  var EDGE_FIELDS = { 'edge-bx': 'horizontal', 'edge-by': 'vertical', 'edge-nx': 'longueur', 'edge-ny': 'profondeur', 'edge-r': 'rayon' };
  function gPlace(A, cx, cy) {
    var m = A.svg.getScreenCTM(); if (!m) return null;
    var pt = A.svg.createSVGPoint(); pt.x = cx; pt.y = cy; var p = pt.matrixTransform(m.inverse());
    var best = null, box = { x0: Infinity, y0: Infinity, x1: -Infinity, y1: -Infinity };   /* box : le tracé entier (R148-b3) */
    Array.prototype.forEach.call(A.svg.querySelectorAll('.cp-trace [data-piece]'), function (g) {
      var poly = A.svg.querySelector((g.getAttribute('clip-path') || '').replace(/^url\(|\)$/g, '') + ' polygon');
      if (!poly) return;
      var P = poly.getAttribute('points').trim().split(/\s+/).map(function (s) { return s.split(',').map(Number); });
      var c0 = [0, 0]; P.forEach(function (q) { c0[0] += q[0] / P.length; c0[1] += q[1] / P.length; });
      var xs = P.map(function (q) { return q[0]; }), ys = P.map(function (q) { return q[1]; });
      var pw = Math.max.apply(null, xs) - Math.min.apply(null, xs), ph = Math.max.apply(null, ys) - Math.min.apply(null, ys);
      box.x0 = Math.min(box.x0, Math.min.apply(null, xs)); box.x1 = Math.max(box.x1, Math.max.apply(null, xs));
      box.y0 = Math.min(box.y0, Math.min.apply(null, ys)); box.y1 = Math.max(box.y1, Math.max.apply(null, ys));
      P.forEach(function (a, i) {
        var b = P[(i + 1) % P.length], dx = b[0] - a[0], dy = b[1] - a[1], L2 = dx * dx + dy * dy; if (!L2) return;
        var t = Math.max(0, Math.min(1, ((p.x - a[0]) * dx + (p.y - a[1]) * dy) / L2));
        var d = Math.hypot(p.x - a[0] - t * dx, p.y - a[1] - t * dy);
        if (!best || d < best.d) best = { d: d, id: g.getAttribute('data-piece'), a: a, b: b, t: t, c: c0, pw: pw, ph: ph };
      });
    });
    if (best) best.box = box;
    return best;
  }
  /* R148-b3 (AUDIT 23:28 ; règle de COMMERCIAL, Tour 218) : « {bord} du {pièce} », comme les noms tirés de la clé. Un long bord
     est un « bord » (arrière contre un mur, avant sinon), un petit bord un « côté » (« côté libre » s'il ne touche aucun mur,
     « côté du montant gauche, contre le mur du fond », « côté droit du plan du haut, contre le mur de droite » sinon). Le mur se
     lit sur le tracé entier : en haut, le mur du fond ; à gauche et à droite, les murs de côté. */
  function gEdgeName(A, c) {
    var b = gPlace(A, c[0], c[1]); if (!b) return null;
    var P = G_PIECES[b.id] || b.id, horiz = Math.abs(b.a[1] - b.b[1]) < Math.abs(b.a[0] - b.b[0]), e = 1.5, B = b.box;
    var mx = (b.a[0] + b.b[0]) / 2, my = (b.a[1] + b.b[1]) / 2, long = Math.hypot(b.b[0] - b.a[0], b.b[1] - b.a[1]) > Math.min(b.pw, b.ph) + e;
    if (horiz && long && b.id === 'retour') return (my < b.c[1] ? 'bord avant' : 'bord arrière') + ' du retour';   /* le retour, en bas du G : son avant regarde l'intérieur du G, vers le haut */
    var mur = horiz ? (Math.abs(my - B.y0) < e ? 'du fond' : '') : (Math.abs(mx - B.x0) < e ? 'de gauche' : Math.abs(mx - B.x1) < e ? 'de droite' : '');
    if (long) return (mur ? 'bord arrière du ' : 'bord avant du ') + P;
    if (!mur) return 'côté libre du ' + P;
    return 'côté ' + (horiz ? '' : (mx < b.c[0] ? 'gauche ' : 'droit ')) + 'du ' + P + ', contre le mur ' + mur;
  }
  function gCornerName(A, c) {
    var b = gPlace(A, c[0], c[1]); if (!b) return null;
    var v = b.t < 0.5 ? b.a : b.b;
    return (G_PIECES[b.id] || b.id) + ', ' + (v[1] < b.c[1] ? 'en haut' : 'en bas') + ' ' + (v[0] < b.c[0] ? 'à gauche' : 'à droite');
  }
  /*  « contre le mur » est une formule de plan de travail ; sur un panneau (plaqué chêne,
     mélaminé) ou une crédence, le bord arrière est seulement « bord arrière »*/
  function isWorktop() {
    var h = (window.__PRODUCT__ && window.__PRODUCT__.handle) || (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
    return /^plan-de-travail/.test(h);
  }
  function edgeName(A, k, c) {
    var n = edgeName0(A, k, c);
    return isWorktop() ? n : n.replace(/, contre le mur(?: du fond| de gauche| de droite)?/g, '');
  }
  function edgeName0(A, k, c) {
    var map = EDGE_NAMES[A.S.layout] || {};
    if (A.S.layout === 'u-shape' && k === 'angleReturn' && c) {            /*  la même clé pour les deux jambes*/
      var r = A.svg.getBoundingClientRect();
      return 'bord avant de la ' + (c[0] < r.left + r.width / 2 ? 'jambe gauche' : 'jambe droite');   /* R148-b2 (COMMERCIAL Tour 210) */
    }
    if (map[k]) return map[k];
    if (A.S.layout === 'g-shape') {                                     /* R148-b2 (COMMERCIAL Tour 211) : le nom de la ligne Options, par la clé ; sinon la position */
      var gk = typeof window.CP_nomChantCle === 'function' ? window.CP_nomChantCle(A, k) : null; if (gk) return gk;
      var gn = gEdgeName(A, c); if (gn) return gn;
    }
    var words = k.replace(/_F+$/, '').replace(/[GU]$/, '').split(/(?=[A-Z])/).map(function (w) { return WORDS[w.toLowerCase()] || w.toLowerCase(); });
    return words.join(' ') + ' (' + where(A, c[0], c[1]) + ')';
  }
  /* Noms des coins : clé du moteur (endHTL, topLeft, footLTL, gLeftTL…) */
  var PIECE = { H: 'plan principal', V: 'retour', L: 'jambe gauche', R: 'jambe droite' };
  var GPIECE = { Left: 'montant gauche', Right: 'montant droit', Top: 'plan du haut', Return: 'retour' };   /* N21 : comme G_PIECES */
  /*  le coin est nommé d'après la pièce RÉELLE qui porte son sommet (tracé de cp-trace) ;
     en L en retour filant, le coin extérieur appartient au retour ; en coupe à 45°, aux deux pièces*/
  function pieceName(A, id) {
    var L = A.S.layout;
    if (L === 'u-shape') return { gauche: 'jambe gauche', droite: 'jambe droite', fond: 'fond du U' }[id] || id;
    if (L === 'g-shape') return G_PIECES[id] || id;
    return { plan: 'plan principal', retour: 'retour' }[id] || id;
  }
  function realCornerName(A, c) {
    var m = A.svg.getScreenCTM(); if (!m || !c) return null;
    var pt = A.svg.createSVGPoint(); pt.x = c[0]; pt.y = c[1]; var p = pt.matrixTransform(m.inverse()), polys = [], best = null;
    Array.prototype.forEach.call(A.svg.querySelectorAll('.cp-trace [data-piece]'), function (g) {
      var poly = A.svg.querySelector((g.getAttribute('clip-path') || '').replace(/^url\(|\)$/g, '') + ' polygon'); if (!poly) return;
      var P = poly.getAttribute('points').trim().split(/\s+/).map(function (s) { return s.split(',').map(Number); });
      polys.push({ id: g.getAttribute('data-piece'), P: P });
      P.forEach(function (v) { var d = Math.hypot(v[0] - p.x, v[1] - p.y); if (!best || d < best.d) best = { d: d, v: v }; });
    });
    if (!best || best.d > 400) return null;
    var own = polys.filter(function (o) { return o.P.some(function (v) { return Math.hypot(v[0] - best.v[0], v[1] - best.v[1]) < 1; }); });
    var P0 = own[0].P, c0 = P0.reduce(function (s, q) { return [s[0] + q[0] / P0.length, s[1] + q[1] / P0.length]; }, [0, 0]);
    var pos = (best.v[1] < c0[1] ? 'en haut' : 'en bas') + ' ' + (best.v[0] < c0[0] ? 'à gauche' : 'à droite');
    return A.S.layout === 'linear' ? pos : own.map(function (o) { return pieceName(A, o.id); }).join(' et ') + ', ' + pos;
  }
  function cornerName(A, k, c) {
    var pos = function (tb, lr) { return (tb === 'T' ? 'en haut' : 'en bas') + ' ' + (lr === 'L' ? 'à gauche' : 'à droite'); }, m;
    if (c && (c[0] || c[1]) && /^(end|foot)/.test(k)) { var rc = realCornerName(A, c); if (rc) return rc; }
    if ((m = k.match(/^end([HV])([TB])([LR])$/))) return (m[1] === 'V' && m[2] === 'B' ? 'extrémité du retour' : PIECE[m[1]]) + ', ' + pos(m[2], m[3]);
    if ((m = k.match(/^(top|bottom)(Left|Right)$/))) return pos(m[1] === 'top' ? 'T' : 'B', m[2][0]);
    if ((m = k.match(/^foot([LR])([TB])([LR])$/))) return PIECE[m[1]] + ', ' + pos(m[2], m[3]);
    if (A.S.layout === 'g-shape' && c && (c[0] || c[1])) { var gc = gCornerName(A, c); if (gc) return gc; }
    if ((m = k.match(/^g(Left|Right|Top|Return)([TB])([LR])$/))) return GPIECE[m[1]] + ', ' + pos(m[2], m[3]);
    return where(A, c[0], c[1]);
  }
  /* lot « messages 2 », N17 à N20 (AUDIT Tour 616, point 1) : le titre d'un coin pour le moteur, menu et fenêtre, le même que
     celui que pose cornerTitle, d'après la pièce réelle (G à gauche compris) ; null si le coin n'est pas dessiné */
  window.CP_titreCoin = function (A, k) {
    try { A = A || getApp(); var h = A && A.svg && A.svg.querySelector('rect.hit[data-cp-id="' + k + '"]'); return h ? 'Coin : ' + cornerName(A, k, center(h)) : null; } catch (e) { return null; }
  };

  /* position lisible d'un point de l'écran dans le dessin (repli quand la clé n'est pas connue) */
  function where(A, cx, cy) {
    var r = A.svg.getBoundingClientRect();
    var fx = (cx - r.left) / (r.width || 1), fy = (cy - r.top) / (r.height || 1);
    var v = fy < 0.34 ? 'en haut' : (fy > 0.66 ? 'en bas' : 'au milieu');
    var h = fx < 0.34 ? 'à gauche' : (fx > 0.66 ? 'à droite' : 'au centre');
    return v + ' ' + h;
  }
  function center(el) { var r = el.getBoundingClientRect(); return [r.left + r.width / 2, r.top + r.height / 2]; }

  function injectCss() {
    if (document.getElementById('cp-a11y-css')) return;
    var st = document.createElement('style'); st.id = 'cp-a11y-css';
    st.textContent =
      '#dims .label span[data-cp-a11y]:focus-visible,#dims .edge-checkbox-visual:focus-visible,.cp-a11y-btn:focus-visible,label[data-cp-radio]:focus-visible' +
      '{outline:3px solid #0b3527;outline-offset:2px;border-radius:4px;box-shadow:0 0 0 5px #fff}' +
      /* au-dessus des cases de chant (thème : z-index 1000 !important) : à 375, la zone de 48 px d'une case de bout couvrait
         les boutons des coins voisins (G, bas d'un montant de 600 mm : ~35 px), qui ne s'ouvraient plus au doigt (06/10 13:5x) */
      '.cp-a11y-btn{position:absolute;transform:translate(-50%,-50%);width:32px;height:32px;margin:0;padding:0;border:0;' +
      'background:transparent;pointer-events:none;z-index:1001}' +
      '.cp-aide-cotes{margin:6px 0 8px;font-size:13px;line-height:1.4;color:#374151}' +
      '.cp-aide-cotes .cp-aide-clic{display:none}' +
      '@media (min-width:769px){.cp-aide-cotes .cp-aide-clic{display:inline}.cp-aide-cotes .cp-aide-touche{display:none}}' +
      /*  liste des coins (cibles de 44 px de haut, comme les jonctions sous 481 px)*/
      '.cp-coins summary{display:flex;align-items:center;min-height:44px;cursor:pointer;font-size:13px;font-weight:600;color:#374151}' +
      '.cp-coins__list{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:6px}' +
      '.cp-coin{display:flex;align-items:center;justify-content:space-between;gap:10px;width:100%;min-height:44px;margin:0;padding:6px 12px;' +
      'border:1px solid #d1d5db;border-radius:8px;background:#fff;color:#111827;font:inherit;font-size:13px;line-height:1.3;text-align:left;cursor:pointer}' +
      '.cp-coin__us{flex:none;color:#4b5563}.cp-coin[data-usine] .cp-coin__us{color:#1d4a36;font-weight:600}' +
      '.cp-coin:focus-visible,.cp-coins summary:focus-visible{outline:3px solid #0b3527;outline-offset:2px}';
    document.head.appendChild(st);
  }
  /* une case de chant dont le centre tombe sous un bouton de coin (côté court à 375 : bas d'un montant du G, ~35 px) est
     écartée perpendiculairement au côté, vers l'extérieur du dessin (à l'opposé du centre des coins), juste assez pour
     sortir des boutons : le toucher de la case ne fait que le chant, celui du coin ouvre ses types (Romain, AUDIT 12:36).
     À 1440, aucune case n'est sous un coin : rien ne bouge. Appelée après chaque rendu, et par cp-pierre-angle après avoir
     replacé la case d'un bout coupé. Rend true si une case a bougé (A-308 : les chiffres gris sont alors à replacer).
     R202 (AUDIT, 01/11 17:15) : une case ne quitte jamais son bord. Écartée perpendiculairement, la case gauche d'un plan
     droit à 375 sortait du plan, à côté de la cote, et la droite rentrait dedans. Elle glisse maintenant le long de son
     bord, entre ses deux coins, jusqu'à ce que son carré visible ne touche plus la partie visible d'un coin (carré vert)
     ni une cote orange. Sans place libre, elle reste au milieu de son bord. Les boîtes de 44 du toucher sont ensuite
     taillées (tailleBoites, A-354) : un toucher ne va qu'à une cible */
  function eloigneCases(A) {
    if (!A || !A.dims) return false;
    var vis = function (r) { return { l: r.left, t: r.top, r: r.right, b: r.bottom }; };
    var bts = [].slice.call(A.dims.querySelectorAll('.cp-a11y-btn[data-cp-kind="hit"]')).filter(function (b) { return b.getBoundingClientRect().width > 0; }).map(function (b) {
      var r = b.getBoundingClientRect(), o = { x: r.left + r.width / 2, y: r.top + r.height / 2 }, t = b.__cpTarget && b.__cpTarget.isConnected ? b.__cpTarget.getBoundingClientRect() : null;
      o.v = t && t.width > 0 ? vis(t) : { l: o.x - 3, t: o.y - 3, r: o.x + 3, b: o.y + 3 }; return o;
    });
    if (bts.length < 2) return false;
    var obs = bts.map(function (b) { return b.v; }).concat([].slice.call(A.dims.querySelectorAll('.label span[data-cp-a11y]')).map(function (s) { return vis(s.getBoundingClientRect()); })
      .filter(function (q) { return q.r > q.l && q.b > q.t; }));
    var touche = function (q) { return obs.some(function (o) { return Math.min(q.r, o.r) - Math.max(q.l, o.l) > 0 && Math.min(q.b, o.b) - Math.max(q.t, o.t) > 0; }); };
    var bouge = false;
    Array.prototype.forEach.call(A.dims.querySelectorAll('.edge-checkbox-container'), function (box) {
      var cb = box.querySelector('.edge-checkbox-visual'), r = cb && cb.getBoundingClientRect(); if (!r || !r.width) return;
      var c = vis(carreVu(cb)); if (!touche(c)) return;
      var cx = (c.l + c.r) / 2, cy = (c.t + c.b) / 2, hw = (c.r - c.l) / 2, hh = (c.b - c.t) / 2;
      var near = bts.slice().sort(function (a, b) { return Math.hypot(a.x - cx, a.y - cy) - Math.hypot(b.x - cx, b.y - cy); });
      var ux = near[1].x - near[0].x, uy = near[1].y - near[0].y, l = Math.hypot(ux, uy) || 1; ux /= l; uy /= l;
      var s0 = (cx - near[0].x) * ux + (cy - near[0].y) * uy, marge = Math.abs(ux) * hw + Math.abs(uy) * hh;   /* place sur le bord, demi-carré dans son sens */
      for (var d = 2; d <= l / 2; d += 2) for (var sg = -1; sg <= 1; sg += 2) {
        var s = s0 + sg * d; if (s < marge || s > l - marge) continue;   /* entre ses deux coins, sur son bord */
        var dx = ux * sg * d, dy = uy * sg * d;
        if (!touche({ l: c.l + dx, t: c.t + dy, r: c.r + dx, b: c.b + dy })) { box.style.left = (parseFloat(box.style.left) + dx) + 'px'; box.style.top = (parseFloat(box.style.top) + dy) + 'px'; bouge = true; return; }
      }
    });
    try { tailleBoites(A); } catch (e) {}
    return bouge;
  }
  /* A-354 (AUDIT Tour 713, STYLE Tour 58 ; choix A) : au doigt, la boîte de 44 d'une case ou d'un bouton de coin ne couvre
     la partie visible d'aucune autre cible : autres cases (imposées comprises), carrés des coins, pastilles des cotes
     orange et des badges. En G à 375, deux cases voisines (retour, montant droit, cases d'arrière du lot « formes ») et la
     case du bas d'un montant de 34 px, entre ses deux coins, avaient leur carré sous la boîte d'une autre cible : le
     toucher cochait la voisine. Rien ne bouge : la boîte est taillée (clip-path, qui vaut aussi pour le toucher) du côté
     de la partie visible qu'elle couvre, à mi-chemin entre les deux parties visibles (au bord de la pastille pour une cote
     qui n'est pas taillée), en gardant son propre carré entier. Le côté retenu laisse la plus grande boîte, 24 px au moins
     dans chaque sens si possible. R2 (AUDIT Tour 714) : la boîte d'un badge est taillée de même, contre la pastille d'un
     autre badge et toute partie visible. Recalculé en entier à chaque passage : rien ne s'additionne. À la souris (cases
     de 15, boutons de 32), aucune boîte n'est taillée */
  function tailleBoites(A) {
    var gros = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    var R = function (l, t, w, h) { return { l: l, t: t, r: l + w, b: t + h }; };
    var rect = function (e) { var r = e.getBoundingClientRect(); return R(r.left, r.top, r.width, r.height); };
    var avant = function (e, r) {                                       /* pastille en ::before (carré de la case, badge), sinon l'élément */
      var s = getComputedStyle(e, '::before'), x = parseFloat(s.left), y = parseFloat(s.top), xr = parseFloat(s.right), yb = parseFloat(s.bottom);
      if (s.content === 'none' || s.content === 'normal' || s.position !== 'absolute' || ![x, y, xr, yb].every(isFinite)) return r;
      return { l: r.l + x, t: r.t + y, r: r.r - xr, b: r.b - yb };
    };
    var vu = function (e) { return e.getClientRects().length > 0; };
    veilleTaille(A);
    var cibles = [];
    Array.prototype.forEach.call(A.dims.querySelectorAll('.cp-a11y-btn[data-cp-kind="hit"]'), function (b) {
      if (!vu(b)) return;
      var bx = rect(b), t = b.__cpTarget && b.__cpTarget.isConnected ? rect(b.__cpTarget) : null;
      cibles.push({ el: b, boite: bx, vis: t && t.r > t.l ? t : R((bx.l + bx.r) / 2 - 3, (bx.t + bx.b) / 2 - 3, 6, 6), taille: true });
    });
    Array.prototype.forEach.call(A.dims.querySelectorAll('.edge-checkbox-visual'), function (cb) {
      var box = cb.closest('.edge-checkbox-container');
      if (!vu(cb) || !box) return; var bx = rect(box), vs = avant(cb, rect(cb));
      cibles.push({ el: box, boite: bx, vis: vs, taille: !cb.classList.contains('disabled') && vs.r - vs.l < bx.r - bx.l });   /* une case imposée n'a pas de boîte à elle */
    });
    Array.prototype.forEach.call(A.dims.querySelectorAll('.cp-angle-coin, .cp-angle-int'), function (b) {
      if (!vu(b)) return; var bx = rect(b), vs = avant(b, bx);
      cibles.push({ el: b, boite: bx, vis: vs, taille: vs.r - vs.l < bx.r - bx.l || vs.b - vs.t < bx.b - bx.t });   /* R2 : pastille plus petite que la boîte */
    });
    var pose = function (el, v) { if (el.__cpClip !== v || (v && !el.style.clipPath)) { el.style.clipPath = v; el.__cpClip = v; } };   /* rien d'écrit sans changement */
    if (!gros) { cibles.forEach(function (o) { pose(o.el, ''); }); return; }
    Array.prototype.forEach.call(A.dims.querySelectorAll('.label span[data-cp-a11y]'), function (s) {   /* pastille de la cote, avec une marge d'un demi-pixel */
      if (!vu(s)) return; var l = s.closest('.label'), p = l ? rect(l) : rect(s); cibles.push({ boite: rect(s), vis: { l: p.l - 0.5, t: p.t - 0.5, r: p.r + 0.5, b: p.b + 0.5 } });
    });
    var coupe = function (a, b) { return a.l < b.r && b.l < a.r && a.t < b.b && b.t < a.b; };
    var note = function (k) { var w = k.r - k.l, h = k.b - k.t; return [Math.min(w, h) >= 24 ? 1 : 0, w * h]; };
    cibles.forEach(function (o) {
      if (!o.el) return;
      if (!o.taille) { pose(o.el, ''); return; }
      var k = { l: o.boite.l, t: o.boite.t, r: o.boite.r, b: o.boite.b }, v = o.vis;
      cibles.forEach(function (c) {
        if (c === o || !coupe(k, c.vis)) return;
        var w = c.vis, m = function (a, b) { return c.taille ? (a + b) / 2 : b; }, opts = [];
        if (w.l >= v.r) opts.push({ l: k.l, t: k.t, r: Math.min(k.r, m(v.r, w.l)), b: k.b });
        if (w.r <= v.l) opts.push({ l: Math.max(k.l, m(v.l, w.r)), t: k.t, r: k.r, b: k.b });
        if (w.t >= v.b) opts.push({ l: k.l, t: k.t, r: k.r, b: Math.min(k.b, m(v.b, w.t)) });
        if (w.b <= v.t) opts.push({ l: k.l, t: Math.max(k.t, m(v.t, w.b)), r: k.r, b: k.b });
        opts.sort(function (p, q) { var a = note(p), b = note(q); return b[0] - a[0] || b[1] - a[1]; });
        if (opts.length) k = opts[0];                                    /* parties visibles qui se chevauchent : rien à tailler */
      });
      var i = [k.t - o.boite.t, o.boite.r - k.r, o.boite.b - k.b, k.l - o.boite.l].map(function (x) { return x > 0.001 ? Math.ceil(x * 10) / 10 : 0; });   /* arrondi vers l'intérieur de la boîte */
      pose(o.el, i.some(function (x) { return x > 0; }) ? 'inset(' + i.join('px ') + 'px)' : '');
    });
  }
  /* R2 : les badges (cp-pierre-angle) se placent sur leurs propres passes, après celles de cp-a11y : la taille est refaite à
     l'image qui suit un changement de place, de classe ou d'élément dans le dessin. Ce que la taille écrit ne la relance pas */
  function veilleTaille(A) {
    var d = A && A.dims; if (!d || d.__cpVeilleTaille || typeof MutationObserver !== 'function') return;
    var prevu = false, mo = new MutationObserver(function () {
      if (prevu) return; prevu = true;
      requestAnimationFrame(function () { prevu = false; var B = getApp(); if (B && B.dims === d) { try { tailleBoites(B); } catch (e) {} } mo.takeRecords(); });
    });
    mo.observe(d, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class'] });
    d.__cpVeilleTaille = mo;
  }
  /* C5 (lot téléphone) : deux boutons de coin dont les boîtes se recouvrent (au doigt, 44 px ; à 375, une pièce de 600 mm
     fait 34 px : gLeftBL et gLeftBR du G) s'écartent l'un de l'autre, chacun de la moitié du recouvrement, sur l'axe où il
     est le plus petit. Chacun couvre encore son coin ; les deux boîtes se touchent sans se recouvrir. Posés depuis leur
     coin à chaque passage (reposition) : rien ne s'additionne */
  function ecarteCoins(A) {
    var bs = [].slice.call(A.dims.querySelectorAll('.cp-a11y-btn[data-cp-kind="hit"]')).map(function (b) {
      return { b: b, x: parseFloat(b.style.left), y: parseFloat(b.style.top), w: b.offsetWidth, h: b.offsetHeight, dx: 0, dy: 0 };
    }).filter(function (o) { return o.w > 0 && o.h > 0 && isFinite(o.x) && isFinite(o.y); });
    for (var i = 0; i < bs.length; i++) for (var j = i + 1; j < bs.length; j++) {
      var a = bs[i], c = bs[j], ux = c.x - a.x, uy = c.y - a.y, nx = (a.w + c.w) / 2 - Math.abs(ux), ny = (a.h + c.h) / 2 - Math.abs(uy);
      if (!(nx > 0 && ny > 0)) continue;
      if (nx <= ny) { var sx = ux < 0 ? -1 : 1; a.dx -= sx * nx / 2; c.dx += sx * nx / 2; }
      else { var sy = uy < 0 ? -1 : 1; a.dy -= sy * ny / 2; c.dy += sy * ny / 2; }
    }
    bs.forEach(function (o) { if (o.dx || o.dy) { o.b.style.left = (o.x + o.dx) + 'px'; o.b.style.top = (o.y + o.dy) + 'px'; } });
  }
  /* appelée par cp-pierre-angle après avoir posé lui-même une case (bout coupé) : les chiffres gris se replacent autour */
  window.CP_eloigneCases = function (A) { try { var B = A || getApp(); eloigneCases(B); if (B && B.dims) declutter(B); } catch (e) {} };
  /* A-284 (AUDIT, 06/10 12:36) : une case imposée (comprise, livrée finie) reçoit le toucher et ne fait rien, comme au clic à
     la souris. Inerte au doigt (ancienne classe cp-inerte), le toucher était ajusté par Chrome vers le bouton du coin voisin
     et ouvrait ses types : « la case ne gère que le chant » (Romain). Un écouteur de clic (sans effet) en fait une cible du
     toucher. Retire la classe des dessins posés avant ce changement. */
  function inertLocked(A) {
    if (!A || !A.dims) return;
    Array.prototype.forEach.call(A.dims.querySelectorAll('.edge-checkbox-visual'), function (e) {   /* toutes : une case posée hors du moteur (cp-pierre-angle) aussi */
      e.classList.remove('cp-inerte');
      if (!e.__cpCible) { e.__cpCible = true; e.addEventListener('click', function () {}); }
    });
  }

  /*  ligne d'aide permanente au-dessus du dessin. A-133 : ses textes viennent de cp-decor-data (CP_aideCotes, d'après la règle
     retenue : l'angle « 90° » sur une matière qui vend le hors d'équerre), le même texte que la ligne posée dès le départ */
  function helpLine() {
    var stage = document.getElementById('stage');
    if (!stage) return;
    var p = document.getElementById('cp-aide-cotes');
    if (!p) {
      p = document.createElement('p');
      p.id = 'cp-aide-cotes'; p.className = 'cp-aide-cotes';
      p.innerHTML = '<span class="cp-aide-touche"></span><span class="cp-aide-clic"></span>';
      stage.parentNode.insertBefore(p, stage);
    }
    var tx = typeof window.CP_aideCotes === 'function' ? window.CP_aideCotes()
      : ['Touchez une cote orange pour saisir vos mesures en millimètres.', 'Cliquez sur une cote orange pour saisir vos mesures en millimètres.'];
    var t = p.querySelector('.cp-aide-touche'), c = p.querySelector('.cp-aide-clic');
    if (t && t.textContent !== tx[0]) t.textContent = tx[0];
    if (c && c.textContent !== tx[1]) c.textContent = tx[1];
  }

  /* ── identité d'une commande, pour retrouver son équivalent après un rendu ── */
  var lastTrigger = null;
  function identify(el) {
    if (!el || !el.closest) return null;
    if (el.id && el.matches && el.matches(OPENERS)) return { t: 'id', k: el.id };
    if (el.dataset && el.dataset.cpA11y === 'dim') return { t: 'dim', k: el.dataset.cpKey };
    if (el.classList && el.classList.contains('edge-checkbox-visual')) return { t: 'edge', k: el.dataset.edge };
    if (el.classList && el.classList.contains('cp-a11y-btn')) return { t: el.dataset.cpKind, k: el.dataset.cpKey };
    if (el.classList && el.classList.contains('cp-coin')) return { t: 'coinlist', k: el.dataset.cpKey };
    return null;
  }
  function find(A, id) {
    if (!id) return null;
    if (id.t === 'id') return document.getElementById(id.k);
    if (id.t === 'coinlist') return coinsBox && coinsBox.querySelector('.cp-coin[data-cp-key="' + id.k + '"]');
    if (!A.dims) return null;
    if (id.t === 'dim') return A.dims.querySelector('span[data-cp-a11y="dim"][data-cp-key="' + id.k + '"]');
    if (id.t === 'edge') return A.dims.querySelector('.edge-checkbox-visual[data-edge="' + id.k + '"]');
    return A.dims.querySelector('.cp-a11y-btn[data-cp-kind="' + id.t + '"][data-cp-key="' + id.k + '"]');
  }
  function focusBack(A, id) {
    var el = find(A, id); if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    /*  ligne de la liste des coins activée au clavier, page défilée jusqu'au dessin : la ligne revient à
       l'écran, sinon le focus y serait invisible. À la souris, la vue reste sur le dessin (le coin usiné).*/
    if (id.t === 'coinlist' && id.kbd) {
      var r = el.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) el.scrollIntoView({ block: 'center' });   /* comme un focus natif */
    }
  }

  /* ── fenêtres du configurateur : focus dedans, Tab piégé, Entrée valide, Échap ferme ──
     Chaque fenêtre a sa façon de se fermer.*/
  function clickFirst(sel) { var b = document.querySelector(sel); if (b) b.click(); }
  function configBar() { try { return (typeof ConfigBar !== 'undefined') ? ConfigBar : null; } catch (e) { return null; } }
  var DIALOGS = [
    { sel: '#edge-dims-popup', close: function (A) { if (A.closeEdgePopup) A.closeEdgePopup(); } },
    { sel: '#edge-menu', close: function (A) { if (A.closeMenu) A.closeMenu(); } },
    { sel: '#legs-popup', close: function () { clickFirst('#legs-cancel, #legs-popup-close'); } },
    { sel: '#sink-popup', close: function () { clickFirst('#sink-cancel, #sink-popup-close'); } },
    { sel: '.config-popup', close: function () { var cb = configBar(); if (cb && cb.close) cb.close(); else clickFirst('.config-popup.is-open .config-popup-close'); } }
  ];
  /* boutons (permanents) qui ouvrent une fenêtre : le focus y revient à la fermeture */
  var OPENERS = '#btn-add-legs, #btn-add-sink, [id^="bar-btn-"]';
  function visible(el) { return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'); }
  function openDialog() {
    for (var d = 0; d < DIALOGS.length; d++) {
      var list = document.querySelectorAll(DIALOGS[d].sel);
      for (var i = 0; i < list.length; i++) if (!list[i].classList.contains('hidden') && visible(list[i])) return { el: list[i], d: DIALOGS[d] };
    }
    return null;
  }
  function openPopup() { var o = openDialog(); return o ? o.el : null; }
  function focusables(pop) {
    return Array.prototype.filter.call(pop.querySelectorAll('input:not([type="hidden"]), select, button, [tabindex="0"]'), function (el) {
      return !el.disabled && visible(el);
    });
  }
  /* Options à bouton radio MASQUÉ (display:none) : finition, épaisseur, épaisseur des jambages…
     Le label devient le choix au clavier (role radio, aria-checked, Entrée/Espace, flèches). */
  function syncChecks(pop) {
    Array.prototype.forEach.call(pop.querySelectorAll('label[data-cp-radio]'), function (lb) {
      var r = lb.__cpInput; if (r) lb.setAttribute('aria-checked', r.checked ? 'true' : 'false');
    });
  }
  function enhanceDialog(pop) {
    var groups = {};
    Array.prototype.forEach.call(pop.querySelectorAll('label'), function (lb) {
      var r = lb.querySelector('input[type="radio"], input[type="checkbox"]') || (lb.htmlFor ? document.getElementById(lb.htmlFor) : null);
      if (!r || visible(r)) return;                                      /* input déjà atteignable : rien à faire */
      lb.__cpInput = r; lb.setAttribute('data-cp-radio', r.name || '');
      lb.setAttribute('role', r.type === 'checkbox' ? 'checkbox' : 'radio');
      lb.setAttribute('aria-checked', r.checked ? 'true' : 'false');
      if (!lb.getAttribute('aria-label')) lb.setAttribute('aria-label', ((lb.textContent || '').trim() || r.value).replace(/\s+/g, ' '));
      (groups[r.name] = groups[r.name] || []).push(lb);
      if (lb.__cpKey) return;
      lb.__cpKey = true;
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault(); lb.click(); setTimeout(function () { syncChecks(pop); }, 0);   /* retour du focus : watchClose */
        } else if (/^Arrow(Right|Down|Left|Up)$/.test(e.key)) {
          var g = Array.prototype.filter.call(pop.querySelectorAll('label[data-cp-radio="' + (r.name || '') + '"]'), visible), i = g.indexOf(lb);
          if (i < 0 || !g.length) return;
          e.preventDefault();
          var nx = g[(i + (/Right|Down/.test(e.key) ? 1 : g.length - 1)) % g.length];
          lb.setAttribute('tabindex', '-1'); nx.setAttribute('tabindex', '0'); nx.focus();   /* tabindex itinérant */
        }
      });
    });
    var title = pop.querySelector('#edge-popup-title, h2, h3, [class*="title"]');
    var titleTxt = title ? title.textContent.trim().replace(/\s+/g, ' ') : '';
    Object.keys(groups).forEach(function (n) {
      var g = groups[n], parent = g[0].parentNode;
      /* un seul arrêt de tabulation par groupe : l'option cochée (sinon la première) ; flèches pour le reste */
      var on = g.filter(function (lb) { return lb.getAttribute('aria-checked') === 'true'; })[0] || g[0];
      g.forEach(function (lb) { if (lb !== on && document.activeElement !== lb) lb.setAttribute('tabindex', '-1'); });
      if (!g.some(function (lb) { return lb.getAttribute('tabindex') === '0'; })) on.setAttribute('tabindex', '0');
      if (parent && g.every(function (lb) { return lb.parentNode === parent; }) && !parent.getAttribute('role')) {
        parent.setAttribute('role', g[0].getAttribute('role') === 'radio' ? 'radiogroup' : 'group');
        if (titleTxt) parent.setAttribute('aria-label', titleTxt);
      }
    });
    /* option en cours annoncée (profondeur, forme, usinage) */
    Array.prototype.forEach.call(pop.querySelectorAll('.depth-btn, .layout-btn, .em-opt'), function (b) {
      b.setAttribute('aria-pressed', (b.classList.contains('selected') || b.classList.contains('active')) ? 'true' : 'false');
    });
    /* champs de saisie sans libellé (cote, profondeur sur mesure) : nommés d'après la fenêtre et leurs bornes */
    Array.prototype.forEach.call(pop.querySelectorAll('input[type="number"], input[type="text"]'), function (i) {
      /*  pavé numérique et touche « OK » (mm entiers) ; posés avant le focus de focusPopup*/
      if (i.type === 'number') {
        if (!i.hasAttribute('inputmode')) i.setAttribute('inputmode', 'numeric');
        if (!i.hasAttribute('enterkeyhint')) i.setAttribute('enterkeyhint', 'done');
      }
      if (EDGE_FIELDS[i.id]) {                             /*  « Chanfrein, horizontal, de 10 à 2370 mm »*/
        var B = getApp(), ty = B && B.S && ({ bevel: 'Chanfrein', notch: 'Encoche', round1: 'Coin arrondi' })[(B.S.edges || {})[B.currentEdgeKey]];
        var nm = (ty ? ty + ', ' : '') + EDGE_FIELDS[i.id] + (i.min && i.max ? ', de ' + i.min + ' à ' + i.max + ' mm' : '');
        i.setAttribute('aria-label', nm.charAt(0).toUpperCase() + nm.slice(1));
        Array.prototype.forEach.call(pop.querySelectorAll('.ni-step[data-for="' + i.id + '"]'), function (b) {
          b.setAttribute('aria-label', (b.getAttribute('data-step') === '-1' ? 'Diminuer' : 'Augmenter') + ' (' + EDGE_FIELDS[i.id] + ')');
        });
        return;
      }
      if (i.getAttribute('aria-labelledby') || (i.labels && i.labels.length && (i.labels[0].textContent || '').trim().length > 4)) return;
      var lab = ({ 'depth-custom-value': motP() + ' sur mesure', 'leg-height': 'Hauteur du jambage' })[i.id] || titleTxt.replace(/\s*\(.*\)\s*$/, '');
      if (i.min && i.max) lab += ', de ' + i.min + ' à ' + i.max + ' mm';
      if (lab) i.setAttribute('aria-label', lab);
    });
    /* boutons sans texte parlant (« + » des jambages) : leur title devient leur nom */
    Array.prototype.forEach.call(pop.querySelectorAll('button[title]:not([aria-label])'), function (b) {
      if (b.textContent.trim().length <= 2) b.setAttribute('aria-label', b.getAttribute('title'));
    });
    /* croix de fermeture : « Fermer » plutôt que « × » */
    Array.prototype.forEach.call(pop.querySelectorAll('button:not([aria-label])'), function (b) {
      if (/^[×✕✖xX]$/.test(b.textContent.trim())) b.setAttribute('aria-label', 'Fermer');
    });
    /* menu des usinages : flèches entre les options */
    if (pop.id === 'edge-menu' && !pop.__cpArrows) {
      pop.__cpArrows = true;
      pop.addEventListener('keydown', function (e) {
        if (!/^Arrow(Right|Down|Left|Up)$/.test(e.key)) return;
        var o = Array.prototype.filter.call(pop.querySelectorAll('.em-opt'), visible), i = o.indexOf(document.activeElement);
        if (!o.length) return;
        e.preventDefault();
        var nx = o[i < 0 ? 0 : (i + (/Right|Down/.test(e.key) ? 1 : o.length - 1)) % o.length];
        try { nx.focus({ preventScroll: true }); } catch (err) { nx.focus(); }
      });
    }
  }
  /* Titres du menu et de la fenêtre de réglage d'un coin : le moteur écrit un libellé interne
     (« Barre H - HD » + « Coin arrondi · +89€ ») -> « Coin : plan principal, en haut à droite » et
     « Coin arrondi (plan principal, en haut à droite) · +89 € »*/
  function triggerCenter(A) {                  /* ligne de la liste des coins : le nom vient du coin dans le dessin */
    var id = lastTrigger && lastTrigger.t === 'coinlist' ? { t: 'hit', k: lastTrigger.k } : lastTrigger, el = find(A, id);
    return el ? center(el) : [0, 0];
  }
  function cornerTitle(A, pop) {
    if (lastTrigger && lastTrigger.t === 'dim') return dimTitle(pop);
    if (!lastTrigger || (lastTrigger.t !== 'hit' && lastTrigger.t !== 'coinlist')) return;
    if (pop.id === 'edge-menu') {
      var mt = document.getElementById('menu-title');
      if (mt) mt.textContent = 'Coin : ' + cornerName(A, lastTrigger.k, triggerCenter(A));
      return;
    }
    if (pop.id !== 'edge-dims-popup') return;
    var t = document.getElementById('edge-popup-title'), tag = t && t.querySelector('.ep-tag');
    if (!tag || tag.__cpDone) return;
    var nom = cornerName(A, lastTrigger.k, triggerCenter(A));
    Array.prototype.slice.call(t.childNodes).forEach(function (n) { if (n.nodeType === 3) n.remove(); });
    tag.textContent = tag.textContent.replace(/\s*·\s*/, ' (' + nom + ') · ').replace(/(\d)\s*€/, '$1 €');
    tag.__cpDone = true;
  }
  /* Fenêtre d'une cote : « Dimension : de 300 à 4 180 mm » -> « Longueur L1 : de 300 à 4 180 mm » (lot « messages 2 », T2 ;
     « Dimension (300–4180 mm) » avant)*/
  function dimTitle(pop) {
    var k = lastTrigger.k, t = document.getElementById('edge-popup-title');
    if (pop.id !== 'edge-dims-popup') return;
    var mp = motP(), named = !!t && /^[LP]\d$/.test(k || ''), nom = named ? (k[0] === 'P' ? mp + ' ' + (mp === 'Hauteur' ? 'H' + k.slice(1) : k) : 'Longueur ' + k) : '';   /* A-364 : « Hauteur H1 » sur une crédence */
    /* lot « messages 2 », M1 (COMMERCIAL § M, AUDIT Tour 667) : « Profondeur (300–1200 mm) » du moteur prend la forme des
       aides, comme la longueur (T2) : « Profondeur P1 : de 300 à 1 200 mm », « Hauteur P1 : … » sur une crédence ; sans nom
       de cote : « Profondeur : de 300 à 1 200 mm » */
    var s = t ? t.textContent.trim() : '', pl = s.match(/^(Dimension|Profondeur) \((\d[\d\s]*)\s*[–-]\s*(\d[\d\s]*)\s*mm\)$/);
    var mil = function (x) { return String(Number(String(x).replace(/\s/g, ''))).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
    if (pl) s = pl[1] + ' : de ' + mil(pl[2]) + ' à ' + mil(pl[3]) + ' mm';
    if (named) {
      if (/^(Dimension|Profondeur)( \(| : )/.test(s)) t.textContent = s.replace(/^(Dimension|Profondeur)/, nom);
      else if (s === 'Choisir une profondeur') t.textContent = mp === 'Hauteur' ? 'Choisir la hauteur' : 'Choisir la profondeur ' + k;
    } else if (pl && pl[1] === 'Profondeur') t.textContent = s.replace(/^Profondeur/, mp);
    /* A-380 (AUDIT 21:01:11, R119) : plan droit, la longueur bornée par le décor choisi (custom.dimensions_max_mm, CP_DMAX, comme
       dmaxCheck de cp-modele) : le titre et le champ disent son maximum ; sans lui, celui de la règle, comme avant */
    var A0 = getApp(), lin = A0 && A0.S && A0.S.layout === 'linear' && named && k[0] === 'L';
    var v0 = lin && A0.getSelectedShopifyVariant ? A0.getSelectedShopifyVariant() : null, dm0 = v0 && window.CP_DMAX && window.CP_DMAX[v0.title];
    var lmax = dm0 ? Number(dm0.l) || 0 : 0, mx0 = t ? t.textContent.match(/ à ([\d\s  ]+) mm$/) : null;
    if (lmax > 0 && mx0 && lmax < Number(mx0[1].replace(/\D/g, ''))) {
      t.textContent = t.textContent.replace(/ à [\d\s  ]+ mm$/, ' à ' + mil(lmax) + ' mm');
      var in0 = pop.querySelector('#dim-normal-input'); if (in0) in0.max = lmax;
    }
    /*  « mm : [2400] mm » (configurator-main l. 2517 et 2582), l'unité écrite deux fois. Le
       libellé de gauche prend le nom de la cote (« L1 : ») et nomme le champ ; sans nom connu, il est masqué.
       L'unité reste à droite du champ.*/
    Array.prototype.forEach.call(pop.querySelectorAll('.input-group'), function (g) {
      var lb = g.querySelector('label'), inp = g.querySelector('input');
      if (!lb || !/^mm\s*:$/.test(lb.textContent.trim())) return;
      if (!named) { lb.hidden = true; return; }
      lb.textContent = k + ' :';
      if (inp && inp.id) { lb.htmlFor = inp.id; if (!inp.getAttribute('aria-label')) inp.setAttribute('aria-label', nom + ', en mm'); }
    });
  }
  /* Après un clic dans une fenêtre : si elle se ferme (souvent avec une animation), le focus
     revient au bouton qui l'a ouverte, au lieu de rester sur une option cachée ou sur la page. */
  function watchClose(pop) {
    var tries = 0;
    (function tick() {
      if (!pop.isConnected || pop.classList.contains('hidden') || !visible(pop) || openPopup() !== pop) {
        var a = document.activeElement;
        if (!a || a === document.body || !visible(a) || pop.contains(a)) focusBack(getApp(), lastTrigger);
        return;
      }
      if (++tries < 12) setTimeout(tick, 60); else syncChecks(pop);
    })();
  }
  function focusPopup(A) {
    setTimeout(function () {
      var pop = openPopup(); if (!pop) return;
      cornerTitle(A, pop);
      enhanceDialog(pop);
      if (!pop.hasAttribute('role')) {                                     /* fenêtre annoncée comme telle */
        pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-modal', 'true');
      }
      /* même fenêtre pour plusieurs réglages : son nom suit le titre du moment */
      var tt = pop.querySelector('#edge-popup-title, h2, h3, [class*="title"]');
      if (tt && tt.textContent.trim()) pop.setAttribute('aria-label', tt.textContent.trim().replace(/\s+/g, ' ').slice(0, 80));
      /* option en cours d'abord (profondeur, usinage, forme, décor, épaisseur), sinon le premier champ visible */
      var cur = Array.prototype.filter.call(pop.querySelectorAll('.depth-btn.selected, .em-opt.active, label[data-cp-radio][aria-checked="true"], input[type="radio"]:checked, .selected, .active, .is-active, [aria-pressed="true"], [aria-checked="true"]'),
        function (el) { return visible(el) && (el.tagName === 'BUTTON' || el.getAttribute('tabindex') === '0' || el.tagName === 'INPUT'); })[0];
      var f = cur || focusables(pop).filter(function (el) { return el.tagName === 'INPUT'; })[0] || focusables(pop)[0];
      /*  sans défilement (les fenêtres sont posées à l'écran par le moteur ; un focus qui défile #stage en
         sortait le dessin)*/
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } if (f.tagName === 'INPUT' && f.select) try { f.select(); } catch (e) {} }
    }, 0);
  }
  function onPopupKey(e) {
    var A = getApp(); if (!A) return;
    var o = openDialog();
    if (!o) return;
    var pop = o.el;
    if (e.key === 'Escape') {                                              /* où que soit le focus */
      e.preventDefault(); e.stopPropagation();
      o.d.close(A);
      if (A.closeEdgePopup && o.el.id === 'edge-menu') A.closeEdgePopup();
      focusBack(A, lastTrigger);
      return;
    }
    if (e.key === 'Tab') {                                                 /* focus piégé dans la fenêtre ouverte */
      var f = focusables(pop); if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      e.preventDefault();
      if (i < 0) f[0].focus();
      else f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus();
      return;
    }
    if (e.key === 'Enter' && e.target.tagName === 'INPUT' && pop.contains(e.target)) {
      var btn = pop.querySelector('#dim-normal-apply, #depth-normal-apply, #depth-apply, #edge-apply, #legs-apply, #sink-apply, button[id$="apply"]');
      if (btn) { e.preventDefault(); btn.click(); }
    }
  }

  /*  usinage d'un coin — rayon (10–200), chanfrein, encoche (30–2 370 × 30–570). Une valeur hors
     bornes était ramenée à la borne par le moteur, sans un mot (9 → 10, 201 → 200, 2 371 → 2 370, 571 → 570).
     « Appliquer » ou Entrée : la valeur est ramenée DANS le champ, avec un message, fenêtre ouverte ; un second
     « Appliquer » l'enregistre. Sur window en capture, avant le moteur.*/
  function mmTxt(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
  function edgeNote(pop, msgs) {
    var n = pop.querySelector('#cp-edge-note');
    if (!msgs.length) { if (n) n.hidden = true; return; }
    if (!n) {
      /* SOUS les boutons : posé au-dessus, il faisait descendre « Appliquer » entre l'appui et le relâché (le message
         apparaît quand le champ est quitté, à l'appui) et le clic était perdu */
      var ap = pop.querySelector('#edge-apply'), host = ap && (ap.closest('.edge-actions') || ap);
      n = document.createElement('p'); n.id = 'cp-edge-note'; n.setAttribute('role', 'alert');
      n.style.cssText = 'margin:.5rem 0 0;font-size:14px;line-height:1.4;color:#b42318;text-align:left';
      if (host && host.parentNode) host.parentNode.insertBefore(n, host.nextSibling); else pop.appendChild(n);
    }
    n.textContent = msgs.join(' '); n.hidden = false;
  }
  /* Le moteur ramène la valeur lui-même, à la frappe (chanfrein, encoche) ou quand le champ est quitté (rayon : au clic
     sur « Appliquer », avant le clic) : la valeur tapée est relevée en capture, avant lui ; le premier « Appliquer »
     qui suit une valeur ramenée est retenu (message lu, valeur corrigée visible), le suivant enregistre. */
  var edgeFixed = {};
  function edgeMsgs() {
    var B = getApp(), t = B && B.S && (B.S.edges || {})[B.currentEdgeKey];
    return Object.keys(edgeFixed).map(function (id) {
      var f = edgeFixed[id], nm = t === 'round1' ? 'Rayon' : t === 'bevel' ? 'Chanfrein ' + EDGE_FIELDS[id] : t === 'notch' ? 'Encoche, ' + EDGE_FIELDS[id]
        : EDGE_FIELDS[id].charAt(0).toUpperCase() + EDGE_FIELDS[id].slice(1);
      return nm + ' : de ' + mmTxt(f.lo) + ' à ' + mmTxt(f.hi) + ' mm, ramené à ' + mmTxt(f.to) + ' mm.';
    });
  }
  /* commit : champ quitté ou « Appliquer » (une valeur trop petite n'est jugée qu'alors) ; seule une frappe du client
     (input) dans les bornes efface l'alerte — au change et au clic, le moteur a DÉJÀ ramené la valeur (2 371 → 2 370) */
  function edgeRead(i, commit) {
    var v = parseFloat(String(i.value).replace(',', '.')), lo = parseFloat(i.min), hi = parseFloat(i.max);
    var to = !isFinite(v) ? null : (isFinite(hi) && v > hi ? hi : (commit && isFinite(lo) && v < lo ? lo : null));
    var stale = false;
    Object.keys(edgeFixed).forEach(function (k) { if (!edgeFixed[k].el.isConnected) { delete edgeFixed[k]; stale = true; } });   /* fenêtre d'un autre coin */
    if (to != null) edgeFixed[i.id] = { lo: lo, hi: hi, to: to, el: i };
    else if (!commit && isFinite(v) && (!isFinite(lo) || v >= lo)) delete edgeFixed[i.id];
    var pop = document.getElementById('edge-dims-popup'); if (!pop) return;
    if (stale) { pop.__cpShown = 0; pop.__cpPass = false; }
    edgeNote(pop, edgeMsgs()); pop.__cpHold = Object.keys(edgeFixed).length > 0;
    if (!pop.__cpHold) pop.__cpShown = 0; else if (!pop.__cpShown) pop.__cpShown = Date.now();   /* message affiché depuis… */
  }
  document.addEventListener('input', function (e) {
    var t = e.target; if (!t || !EDGE_FIELDS[t.id] || !e.isTrusted) return;
    var pop = document.getElementById('edge-dims-popup'); if (pop) pop.__cpPass = false;   /* nouvelle frappe : contrôle réarmé */
    edgeRead(t, false);
  }, true);
  document.addEventListener('change', function (e) { var t = e.target; if (t && EDGE_FIELDS[t.id] && e.isTrusted) edgeRead(t, true); }, true);
  window.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest || !e.target.closest('#edge-apply')) return;
    var pop = document.getElementById('edge-dims-popup'); if (!pop) return;
    /* « Appliquer » qui suit un refus : le client a lu le message, le moteur enregistre (et ramène la valeur, comme avant ;
       il garde parfois la valeur tapée dans son propre modèle et la remet dans le champ) */
    if (pop.__cpPass) { pop.__cpPass = false; edgeFixed = {}; edgeNote(pop, []); return; }
    Object.keys(EDGE_FIELDS).forEach(function (id) {             /* champ encore hors bornes (pas quitté) : ramené ici */
      var i = document.getElementById(id); if (i && visible(i)) edgeRead(i, true);
    });
    if (!pop.__cpHold) { edgeFixed = {}; edgeNote(pop, []); return; }
    /* message déjà affiché avant ce clic (depuis la frappe) : lu, le moteur enregistre la valeur ramenée */
    if (pop.__cpShown && Date.now() - pop.__cpShown > 600) { pop.__cpShown = 0; edgeFixed = {}; return; }
    e.preventDefault(); e.stopPropagation();
    Object.keys(edgeFixed).forEach(function (id) {
      var i = document.getElementById(id); if (i && parseFloat(i.value) !== edgeFixed[id].to) { i.value = String(edgeFixed[id].to); i.dispatchEvent(new Event('input', { bubbles: true })); }
    });
    pop.__cpHold = false; pop.__cpPass = true; edgeFixed = {};     /* le message reste affiché ; « Appliquer » suivant : enregistré */
  }, true);

  function activate(e, el) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return false;
    e.preventDefault();
    return true;
  }

  /* ordre de lecture : de haut en bas, puis de gauche à droite ; deux éléments à moins de 8 px
     de hauteur l'un de l'autre sont sur la même ligne*/
  function byRow(a, b) { return Math.abs(a.c[1] - b.c[1]) > 8 ? a.c[1] - b.c[1] : a.c[0] - b.c[0]; }

  /*  entrée « Usinage des coins » hors du dessin. En G étroit, deux coins peuvent être à 2 px
     l'un de l'autre à l'écran (mesuré à 375 × 667, passage de 500 mm : un coin atteignable à 0 %) ; aucune
     taille de bouton ne les sépare. Liste repliable des coins (nom, usinage en cours), à toutes les formes,
     dans le bloc sous le dessin de cp-trace (#cp-stage-extras, sous 769 px). Chaque ligne rejoue le clic du
     coin, au point du coin après avoir ramené le dessin à l'écran : le menu et la fenêtre du moteur
     (position fixe, placés au point du clic) s'ouvrent à côté du coin. Le focus revient à la ligne après le
     choix (identify / find : 'coinlist').*/
  var coinsBox = null;
  /*  dessin à l'écran avant d'ouvrir le menu d'un coin depuis la liste. Rien à faire s'il est déjà visible à
     90 % avec son coin, ou en plein écran. Centré s'il tient dans l'écran, sinon centré sur le coin. Défilement
     immédiat (le clic est rejoué juste après, aux nouvelles coordonnées du coin).*/
  function showDrawing(A, hit) {
    var st = document.getElementById('stage');
    if (document.fullscreenElement || (st && /\bis-fullscreen/.test(st.className))) return;
    var s = A.svg.getBoundingClientRect(), c = hit.getBoundingClientRect(), vh = window.innerHeight;
    var part = s.height ? Math.max(0, Math.min(s.bottom, vh) - Math.max(s.top, 0)) / Math.min(s.height, vh) : 1;
    if (part >= 0.9 && c.top >= 0 && c.bottom <= vh) return;
    var y = s.height <= vh - 24 ? s.top + s.height / 2 : c.top + c.height / 2;
    scrollNow(y - vh / 2);
  }
  function scrollNow(dy) {
    var html = document.documentElement, sb = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(window.pageXOffset, window.pageYOffset + dy);
    html.style.scrollBehavior = sb;
  }
  /* suite : au téléphone, le menu ne suit pas le coin — le moteur le pose en haut de l'écran (12 px), en bas, pleine largeur (même condition : max-width 480 px). Mesuré à 375 : coin sous le menu 3 fois sur 3,
     puis 22 à 50 % du dessin caché selon le coin. Menu ouvert et placé, la page défile pour centrer
     le dessin ENTIER dans la plus grande place libre (au-dessus ou au-dessous du menu), ou le coin seul si le dessin
     n'y tient pas. Au-delà de 480 px, le menu est posé à côté du coin : on ne fait défiler que si le coin est dessous.
     Le menu est en position fixe : il ne bouge pas. Depuis la liste ET au toucher direct d'un coin.*/
  var PHONE = '(max-width: 480px)';
  function fitCorner(hit) {
    var st = document.getElementById('stage'), m = document.getElementById('edge-menu'), A = getApp();
    if (!hit || !m || m.classList.contains('hidden') || !visible(m) || document.fullscreenElement || (st && /\bis-fullscreen/.test(st.className))) return;
    var mr = m.getBoundingClientRect(), c = hit.getBoundingClientRect(), vh = window.innerHeight;
    var phone = !!(window.matchMedia && window.matchMedia(PHONE).matches);
    var over = c.left < mr.right && c.right > mr.left && c.top < mr.bottom && c.bottom > mr.top;
    if (!phone && !over) return;
    var above = mr.top, below = vh - mr.bottom, top = above >= below ? 0 : mr.bottom, room = Math.max(above, below);
    var s = phone && A && A.svg ? A.svg.getBoundingClientRect() : null, cy = c.top + c.height / 2;
    /* dessin centré dans la place libre ; s'il n'y tient pas, décalé juste assez pour garder le coin dedans (8 px
       de marge) : le plus de dessin possible, le coin toujours visible */
    var dy = s && s.height ? s.top + s.height / 2 - (top + room / 2) : cy - (top + room / 2);
    var edge = Math.min(c.height / 2 + 8, room / 2), lo = top + edge, hi = top + room - edge;
    if (cy - dy < lo) dy = cy - lo; else if (cy - dy > hi) dy = cy - hi;
    scrollNow(dy);
  }
  function fitLater(k, fallback) {                                 /* menu ouvert et placé ; coin relu (dessin redessiné) */
    setTimeout(function () {
      var C = getApp(), h = k && C && C.svg && C.svg.querySelector('rect.hit[data-cp-id="' + k + '"]');
      fitCorner(h || fallback);
    }, 60);
  }
  document.addEventListener('click', function (e) {                /* toucher direct d'un coin du dessin, au téléphone */
    var t = e.target; if (!e.isTrusted || !t || !t.closest || !(window.matchMedia && window.matchMedia(PHONE).matches)) return;
    /* au doigt, le toucher arrive sur le bouton de coin posé par enhance (.cp-a11y-btn, qui rejoue le clic sur la zone) */
    var b = t.closest('.cp-a11y-btn[data-cp-kind="hit"]'), r = !b && t.matches && t.matches('rect.hit') ? t : null;
    if (b) fitLater(b.dataset.cpKey, b.__cpTarget); else if (r) fitLater(r.getAttribute('data-cp-id'), r);
  }, true);
  function usinageLabel(t) {
    var s = document.querySelector('#edge-menu .em-opt[data-type="' + (t || 'straight') + '"] span');
    return s ? s.textContent.trim() : 'Droit';
  }
  function cornerList(A, btns) {
    if (!coinsBox) {
      coinsBox = document.createElement('details'); coinsBox.id = 'cp-coins'; coinsBox.className = 'cp-coins';
      coinsBox.innerHTML = '<summary></summary><ul class="cp-coins__list"></ul>';
      (window.CP_stageExtras = window.CP_stageExtras || {})['cp-coins'] = coinsBox;   /* placé par cp-trace */
    }
    coinsBox.hidden = !btns.length;
    /*  le nom est celui du bouton du dessin, calculé avant tout changement de la page. Le
       recalculer ici, liste vidée, faisait défiler la page (moins haute) quand la liste était en haut de
       l'écran : les coordonnées relevées avant ne désignaient plus le bon coin (4 noms faux sur 7 en G).
       Nouvelles lignes montées hors de la page, puis échangées d'un coup.*/
    var ul = coinsBox.querySelector('ul'), edges = A.S.edges || {}, n = 0, frag = document.createDocumentFragment();
    btns.forEach(function (x) {
      var k = x.b.dataset.cpKey, t = edges[k], hx = typeof window.CP_usinageBout === 'function' ? window.CP_usinageBout(k) : null;   /* hors équerre du bout (cp-pierre-angle), au carré vert de ce coin */
      var cut = !!(t && t !== 'straight') || !!hx, nom = x.nom;
      if (cut) n++;
      var li = document.createElement('li'), b = document.createElement('button');
      b.type = 'button'; b.className = 'cp-coin'; b.dataset.cpKey = k;
      if (cut) b.setAttribute('data-usine', '');
      b.innerHTML = '<span class="cp-coin__nom"></span><span class="cp-coin__us"></span>';
      b.firstChild.textContent = nom.charAt(0).toUpperCase() + nom.slice(1);
      b.lastChild.textContent = hx || usinageLabel(t) + (t === 'notch' && A.S.notch && A.S.notch[k] && A.S.notch[k].fini && typeof window.CP_notchFini === 'function' && window.CP_notchFini(A) ? ' finie' : '');
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var B = getApp(), r = B && B.svg && B.svg.querySelector('rect.hit[data-cp-id="' + k + '"]'); if (!r) return;
        lastTrigger = { t: 'coinlist', k: k, kbd: e.detail === 0 };
        /*  le menu s'ouvrait à côté de la ligne, dessin hors de l'écran (0 à 17 % visible, coin jamais) :
           on ne voyait pas quel coin on usinait. Le dessin est ramené à l'écran, puis le clic est rejoué au point du
           coin : le menu s'ouvre à côté de lui, comme depuis le dessin.*/
        showDrawing(B, r);
        var p = center(r);
        r.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, clientX: p[0], clientY: p[1] }));
        focusPopup(B);
        fitLater(k, r);
      });
      li.appendChild(b); frag.appendChild(li);
    });
    ul.textContent = ''; ul.appendChild(frag);
    coinsBox.querySelector('summary').textContent = 'Usinage des coins (' + btns.length + ')' + (n ? ' · ' + n + (n > 1 ? ' usinés' : ' usiné') : '');
    if (typeof window.CP_placeStageExtras === 'function') window.CP_placeStageExtras();
  }

  /* R148-b3 (COMMERCIAL, docs\commercial-r148b3-textes.md ; AUDIT 22:13) : un seul style pour le nom lu ET l'infobulle des cases
     de chant : « Chant du {bord} : {état} », puis le prix ou la raison. Prix : celui de la ligne Options du chant (R148-b2), sinon
     le prix d'un chant de la règle (selon la profondeur) ; « compris dans le prix » s'il n'y en a pas. Les modules qui savent
     mieux (bouts, chant arrière, îlot, crédences au mètre) posent le leur, au même style. Crédence : haut, bas, côtés. */
  function lignesChants() {
    var m = {};
    Array.prototype.forEach.call(document.querySelectorAll('#td-options li'), function (li) {
      var x = (li.textContent || '').replace(/\s+/g, ' ').trim().match(/^Chant du (.+?)(?: \(avec [^)]*\))? : \+([\d .,]+?) ?€$/); if (x) m[x[1]] = x[2];
    });
    return m;
  }
  /* R148-b4 (UX 01:03 ; AUDIT Tour 1136) : espaces insécables, des milliers et avant « € » */
  function eur2(v) { return (Math.round(Number(v) * 100) / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
  /* le bord d'une case, tel que le dit son nom lu (« Chant du {bord} : … ») */
  function bordChant(A, k, c) {
    var cred = typeof window.CP_estCredence === 'function' && !!window.CP_estCredence(A);
    var b0 = (cred && { back: 'haut', front: 'bas', sides: 'côté gauche', right: 'côté droit' }[k]) || edgeName0(A, k, c);
    return { contre: /, contre le mur$/.test(b0) && isWorktop(), bord: b0.replace(isWorktop() ? /, contre le mur$/ : /, contre le mur(?: du fond| de gauche| de droite)?$/, '') };   /* « côté du retour, contre le mur du fond » garde ses mots */
  }
  /* lot « pierres », ADMIN Tour 1040 : le bord de la case k, pour la ligne d'un chant dont la clé n'a pas de nom (cp-modele,
     chantsParLigne) ; null si la case n'est pas dessinée */
  window.CP_nomCase = function (A, k) {
    A = A || getApp(); var cb = A && A.S && A.svg && A.dims && k ? A.dims.querySelector('.edge-checkbox-visual[data-edge="' + k + '"]') : null;
    return cb ? bordChant(A, k, center(cb)).bord : null;
  };
  function texteChant(A, k, c, on, dis, lch) {
    /* R148-b4 : une case d'arrière au palier 800 dit son prix (cp-modele) dès le 1er affichage ; avant, le prix générique
       (« +49,00 € ») restait le temps que cp-modele le remplace */
    var b8 = typeof window.CP_texteB80 === 'function' ? window.CP_texteB80(A, k, on, dis) : null; if (b8) return b8;
    var bc = bordChant(A, k, c), contre = bc.contre, bord = bc.bord;
    var pl = (lch || {})[bord], u = Number(A._eff && A._eff.edgeBandingUnitEuro) || 0, prix = pl ? pl + ' €' : (u > 0 ? eur2(u) + ' €' : '');
    /* R182-a (COMMERCIAL Tour 225) : côtés finis d'office par le chant arrière (cœur noir) : « fini d'office avec le chant arrière, +59,00 € » */
    var parArr = (k === 'sides' || k === 'right') && typeof window.CP_arrCotes === 'function' && window.CP_arrCotes(A) === true;
    var etat = on ? (dis ? (pl ? 'fini d\'office' + (parArr ? ' avec le chant arrière' : '') + ', +' + prix : (/^bord avant/.test(bord) ? 'fini, compris dans le prix' : 'fini d\'office, compris dans le prix'))
        : (prix ? 'fini, +' + prix : 'fini, compris dans le prix'))
      : (dis ? 'brut' + (contre ? ', contre le mur' : '') : 'brut. Cocher pour le finir' + (prix ? ', +' + prix : ''));
    return 'Chant du ' + bord + ' : ' + etat + '.';
  }
  window.CP_texteChant = function (A, cb) {
    A = A || getApp(); if (!A || !A.S || !A.svg || !cb) return null;
    return texteChant(A, cb.dataset.edge, center(cb), cb.classList.contains('checked'), cb.classList.contains('disabled'), lignesChants());
  };

  /* ── après chaque rendu : rendre atteignable ce que le moteur vient de poser ── */
  function enhance(A) {
    if (!A.dims || !A.svg) return;
    injectCss();
    helpLine(A);
    var dims = [], edges = [], btns = [];

    /*  plus de bulle native « Cliquez pour modifier la dimension » /
       « … choisir une profondeur » (title du moteur, configurator-main l. 2612) ; le nom accessible reste (aria-label)*/
    Array.prototype.forEach.call(A.dims.querySelectorAll('[title^="Cliquez pour"]'), function (el) {
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', el.getAttribute('title'));
      el.removeAttribute('title');
    });
    /* cotes de saisie (le moteur met un <span> cliquable dans .label) */
    Array.prototype.forEach.call(A.dims.querySelectorAll('.dim:not(.readonly) .label span'), function (sp) {
      /* A-364 : « H1 » est la cote P d'une crédence (cp-modele) : clé P1, nom « Hauteur H1 : 600 mm » */
      var txt = sp.textContent.trim(), m = txt.match(/^([LPH]\d?)\s*:\s*(\d+)/i);
      var key = m ? m[1].toUpperCase().replace(/^H/, 'P') : txt;
      var nom = m ? ((key[0] === 'P' ? motP() + ' ' : 'Longueur ') + m[1].toUpperCase() + ' : ' + m[2] + ' mm') : ('Cote : ' + txt + ' mm');
      sp.dataset.cpA11y = 'dim'; sp.dataset.cpKey = key;
      sp.setAttribute('tabindex', '0'); sp.setAttribute('role', 'button');
      sp.setAttribute('aria-label', nom + '. Modifier');
      if (!sp.__cpKey) {
        sp.__cpKey = true;
        sp.addEventListener('keydown', function (e) { if (activate(e, sp)) { lastTrigger = identify(sp); sp.click(); focusPopup(A); } });
        sp.addEventListener('click', function () { lastTrigger = identify(sp); focusPopup(A); });
      }
      dims.push(sp.closest('.dim'));
    });

    /* chants (R148-b3 : un seul style, nom lu et infobulle) */
    var lch = lignesChants();
    Array.prototype.forEach.call(A.dims.querySelectorAll('.edge-checkbox-visual[data-edge]'), function (cb) {
      var k = cb.dataset.edge, dis = cb.classList.contains('disabled'), c = center(cb);
      var nom = texteChant(A, k, c, cb.classList.contains('checked'), dis, lch);
      cb.setAttribute('role', 'checkbox');
      cb.setAttribute('aria-checked', cb.classList.contains('checked') ? 'true' : 'false');
      cb.setAttribute('aria-label', nom); if (cb.title !== nom) cb.title = nom;
      if (dis) { cb.setAttribute('aria-disabled', 'true'); cb.setAttribute('tabindex', '-1'); }
      else cb.setAttribute('tabindex', '0');
      if (!cb.__cpKey) {
        cb.__cpKey = true;
        cb.addEventListener('keydown', function (e) { if (activate(e, cb)) cb.click(); });
      }
      edges.push({ el: cb.parentNode, c: c });
    });
    edges.sort(byRow);

    /* coins : bouton transparent posé sur chaque zone du moteur. Un rendu imbriqué (report des
       cotes de cp-forme.js pendant un changement de forme) fait passer ici deux fois sur le même
       #dims : on retire d'abord les boutons déjà posés.*/
    Array.prototype.forEach.call(A.dims.querySelectorAll('.cp-a11y-btn'), function (b) { b.remove(); });
    var host = null;                            /* relevé au premier bouton : sans coin ni angle, pas de mise en page forcée */
    var mkBtn = function (kind, key, label, target) {
      var c = center(target), b = document.createElement('button');
      if (!host) host = A.dims.getBoundingClientRect();
      b.type = 'button'; b.className = 'cp-a11y-btn'; b.dataset.cpKind = kind; b.dataset.cpKey = key;
      b.setAttribute('aria-label', label);
      b.style.left = (c[0] - host.left) + 'px'; b.style.top = (c[1] - host.top) + 'px';
      b.addEventListener('click', function (e) {
        /* le moteur ferme menu et fenêtre à tout clic sur la scène qui ne vise pas ses zones
           (configurator-main.js l. 2134-2139) : notre clic ne doit pas remonter jusque-là */
        e.stopPropagation();
        lastTrigger = { t: kind, k: key };
        var p = center(target);
        target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, clientX: p[0], clientY: p[1] }));
        focusPopup(A);
      });
      b.__cpTarget = target;
      return b;
    };
    Array.prototype.forEach.call(A.svg.querySelectorAll('rect.hit'), function (r, i) {
      var k = r.getAttribute('data-cp-id') || ('coin' + i), c = center(r), nom = cornerName(A, k, c);
      btns.push({ b: mkBtn('hit', k, 'Coin : ' + nom + '. Choisir un usinage', r), c: c, nom: nom });   /* nom repris par la liste*/
    });
    btns.sort(byRow);
    A.__cpCoins = btns.map(function (x) { return { k: x.b.dataset.cpKey, nom: x.nom }; });   /* noms de la liste, repris par la commande (encoches) */
    cornerList(A, btns);
    var ov = A.svg.querySelector('.inner-angle-overlay');
    var angleBtn = (ov && !document.getElementById('cp-ang-input'))            /* le champ de cp-trace suffit s'il est là */
      ? mkBtn('angle', 'angle', 'Angle entre les murs : ' + (A.S.innerAngle || 90) + '°. Modifier', ov) : null;

    /* ordre de tabulation : cotes, chants, coins, angle */
    dims.forEach(function (d) { if (d) A.dims.appendChild(d); });
    edges.forEach(function (x) { A.dims.appendChild(x.el); });
    btns.forEach(function (x) { A.dims.appendChild(x.b); });
    if (angleBtn) A.dims.appendChild(angleBtn);

    /* d'autres ajouts (champ d'angle de cp-trace, barre de jonction) peuvent changer la mise
       en page après ce passage : on replace les boutons une fois le rendu terminé */
    setTimeout(reposition, 0);                  /* la barre d'outils est finie dans la même tâche que le rendu */
    requestAnimationFrame(reposition);

    /*  le champ de quantité n'avait aucun nom pour les lecteurs d'écran*/
    var qty = document.getElementById('qty-input');
    if (qty && !qty.getAttribute('aria-label') && !(qty.labels && qty.labels.length)) qty.setAttribute('aria-label', 'Quantité');

    /* total annoncé */
    var tot = document.getElementById('td-prix-total');
    if (tot && !tot.hasAttribute('aria-live')) { tot.setAttribute('aria-live', 'polite'); tot.setAttribute('aria-atomic', 'true'); }
  }

  /* Tout ce qui est posé sur le SVG suit la mise en page (redimensionnement, plein écran, et
     surtout barre d'outils qui change de hauteur APRÈS le rendu : jonction et angle en L).
     Le moteur place cotes et cases de chant une fois, au moment du rendu ; son ResizeObserver ne
     suit que la taille du SVG, pas sa position. Mesuré : en passant au L, toutes les
     cotes étaient décalées de 30 à 66 px. On les replace :
     cotes par le moteur (updateDims), cases de chant par leurs coordonnées relevées, boutons des coins.*/
  function reposition() {
    var A = getApp(); if (!A || !A.dims) return;
    try { if (typeof A.updateDims === 'function') A.updateDims(); } catch (e) {}
    var host = A.dims.getBoundingClientRect();
    Array.prototype.forEach.call(A.dims.querySelectorAll('.edge-checkbox-container'), function (c) {
      if (!c.__cpXY || typeof A.svgToClient !== 'function') return;
      var p = A.svgToClient(c.__cpXY[0], c.__cpXY[1]);
      c.style.left = (p.px - host.left) + 'px'; c.style.top = (p.py - host.top) + 'px';
    });
    Array.prototype.forEach.call(A.dims.querySelectorAll('.cp-a11y-btn'), function (b) {
      if (!b.__cpTarget || !b.__cpTarget.isConnected) return;
      var c = center(b.__cpTarget); b.style.left = (c[0] - host.left) + 'px'; b.style.top = (c[1] - host.top) + 'px';
    });
    try { ecarteCoins(A); } catch (e) {}
    /* A-308 : les cases d'abord, puis les chiffres gris autour de leur place finale (declutter tient les cases pour fixes) */
    try { eloigneCases(A); } catch (e) {}
    try { declutter(A); } catch (e) { console.warn('[cp-a11y] cotes', e); }
    try { inertLocked(A); } catch (e) {}
    setTimeout(function () { try { var B = getApp(); if (eloigneCases(B)) declutter(B); } catch (e) {} }, 300);
    if (typeof window.CP_fitStage === 'function') window.CP_fitStage();   /*  hauteur du cadre (cp-trace)*/
  }

  /* repris après le refus
        (la 1re version poussait des chiffres dans les pièces, gris sur le décor).
     Règle : chaque chiffre d'une cote calculée (.subdivision-label) reste du côté extérieur de SON
     trait noir (.dim-subdivisions), à 12 px au plus ; aucun chiffre sur une pièce ni à moins de 4 px de son
     contour, d'un trait, d'une pointe, d'un repère, d'une case de chant, d'une étiquette ou d'un autre chiffre ;
     pas de glissement au-delà de la longueur de la cote ; faute de place, c'est le cadre qui s'élargit.
     Mesuré (moteur + cp-style, rien de déplacé) : chiffre à 3 px de son trait, flèche orange à 26 px
     (chiffre de 17 px) ; à 375 px, la flèche des cotes latérales est à 5 px du trait, voire côté dessin
     (−13 px), et le chiffre la chevauche.
     Donc, côté par côté, on empile depuis le dessin : trait noir, chiffre (5 px ; 11 px s'il est au droit d'un
     repère), flèche orange (5 px plus loin ; 11 px au droit des pointes), étiquette orange (écart d'origine).
     Si le tout sort du cadre : l'étiquette se rapproche de sa flèche (6 px), puis l'ensemble se rapproche du
     dessin (trait noir à 8 px au moins des pièces), puis le cadre s'élargit (withSideMargin, sideExtra).
     Propriété CSS « translate », qui s'ajoute aux transformations du moteur ; remise à zéro puis recalcul à
     chaque placement (rendu, redimensionnement, barre qui change de hauteur).*/
  var MIN_GAP = 5, TXT_GAP = 5, TXT_MAX = 12, LINE_MIN = 8, PILL_MIN = 6, PILL_FAR = 40;
  function textBox(el) {
    var t = null;
    for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && n.nodeValue.trim()) { t = n; break; }
    if (!t) return el.getBoundingClientRect();
    var rg = document.createRange(); rg.selectNodeContents(t); return rg.getBoundingClientRect();
  }
  /* C4 (lot téléphone) : au doigt, la case de chant est une boîte de 44 px et son carré visible est dessiné en ::before, en
     retrait (P4, cp-style). Un chiffre gris ne s'écarte que de ce carré ; une étiquette orange, de toute la boîte. Sans
     retrait positif (souris, case imposée, ou ::before qui agrandit la zone du toucher), le carré est la boîte. */
  function carreVu(e) {
    var r = e.getBoundingClientRect(), cs = getComputedStyle(e, '::before');
    if (cs.content === 'none' || cs.position !== 'absolute') return r;
    var t = parseFloat(cs.top), rt = parseFloat(cs.right), b = parseFloat(cs.bottom), l = parseFloat(cs.left);
    if (!(t > 0 && rt > 0 && b > 0 && l > 0) || l + rt >= r.width || t + b >= r.height) return r;
    return { left: r.left + l, right: r.right - rt, top: r.top + t, bottom: r.bottom - b, width: r.width - l - rt, height: r.height - t - b };
  }
  /* Pièces du tracé réel (cp-trace, polygones data-piece) en coordonnées écran : obstacles.*/
  function piecePolys(A) {
    var m = A.svg && A.svg.getScreenCTM(), out = [];
    if (!m) return out;
    Array.prototype.forEach.call(A.svg.querySelectorAll('.cp-trace [data-piece]'), function (g) {
      var poly = A.svg.querySelector((g.getAttribute('clip-path') || '').replace(/^url\(["']?|["']?\)$/g, '') + ' polygon');
      if (!poly) return;
      var pts = poly.getAttribute('points').trim().split(/\s+/).map(function (s) {
        var q = s.split(',').map(Number), p = A.svg.createSVGPoint(); p.x = q[0]; p.y = q[1]; p = p.matrixTransform(m); return [p.x, p.y];
      });
      if (pts.length >= 3) out.push(pts);
    });
    /* A-345 : la pièce d'angle, peinte par cp-pierre-angle hors de cp-trace (avant en biais) : une pièce comme les autres */
    Array.prototype.forEach.call(A.svg.querySelectorAll('.cp-pierre-dessin polygon'), function (poly) {
      var pts = poly.getAttribute('points').trim().split(/\s+/).map(function (s) {
        var q = s.split(',').map(Number), p = A.svg.createSVGPoint(); p.x = q[0]; p.y = q[1]; p = p.matrixTransform(m); return [p.x, p.y];
      });
      if (pts.length >= 3) out.push(pts);
    });
    return out;
  }
  /* Forme en G : le placement des étiquettes ne dépend pas de la jonction choisie à chaque coin (retour, plan ou
     montant filant, coupe à 45°). Polygones stables, en coordonnées écran :
     - pour chaque pièce, sa part commune à toutes les jonctions (la pièce quand elle tient chacun de ses coins,
       croisée avec la pièce quand elle ne les tient pas) ;
     - pour chaque coin, la zone entre les bords des deux pièces, où passe le trait de jonction quel qu'il soit.
     Même géométrie que le tracé (CP_geomG, décalée de l'origine du tracé) ; null hors du G ou si elle ne
     correspond pas au tracé (rien ne change alors). */
  function area2(P) { var s = 0; for (var i = 0; i < P.length; i++) { var a = P[i], b = P[(i + 1) % P.length]; s += a[0] * b[1] - b[0] * a[1]; } return s; }
  function clipConvex(P, Q) {                                  /* P ∩ Q, Q convexe */
    var sg = area2(Q) < 0 ? -1 : 1, out = P;
    for (var i = 0; i < Q.length && out.length; i++) {
      var a = Q[i], b = Q[(i + 1) % Q.length], inp = out, side = function (p) { return sg * ((b[0] - a[0]) * (p[1] - a[1]) - (b[1] - a[1]) * (p[0] - a[0])); };
      out = [];
      for (var j = 0; j < inp.length; j++) {
        var p = inp[j], q = inp[(j + 1) % inp.length], sp = side(p), sq = side(q);
        if (sp >= -1e-9) out.push(p);
        if ((sp >= -1e-9) !== (sq >= -1e-9)) { var t = sp / (sp - sq); out.push([p[0] + t * (q[0] - p[0]), p[1] + t * (q[1] - p[1])]); }
      }
    }
    return out;
  }
  function stableG(A) {
    var S = A && A.S, svg = A && A.svg;
    if (!S || !svg || S.layout !== 'g-shape' || typeof window.CP_geomG !== 'function' || typeof window.CP_gParams !== 'function') return null;
    var m = svg.getScreenCTM(); if (!m) return null;
    var s0 = window.CP_gParams(S), geo = function (j) { return window.CP_geomG(Object.assign({}, s0, { top: j, mid: j, ret: j })); };
    var cur = window.CP_geomG(s0), gx = geo('retour'), gy = geo('barre'), dom = {};
    Array.prototype.forEach.call(svg.querySelectorAll('.cp-trace [data-piece]'), function (g) {
      var poly = svg.querySelector((g.getAttribute('clip-path') || '').replace(/^url\(["']?|["']?\)$/g, '') + ' polygon');
      if (poly) dom[g.getAttribute('data-piece')] = poly.getAttribute('points').trim().split(/\s+/).map(function (t) { return t.split(',').map(Number); });
    });
    var c0 = cur.pieces[0], d0 = dom[c0.id]; if (!d0 || !d0.length) return null;
    var O = [d0[0][0] - c0.pts[0][0], d0[0][1] - c0.pts[0][1]];
    var same = cur.pieces.every(function (p) {                     /* le tracé est bien cette géométrie, à l'origine O */
      var d = dom[p.id]; return d && d.length === p.pts.length && p.pts.every(function (q, i) { return Math.abs(d[i][0] - q[0] - O[0]) < 0.5 && Math.abs(d[i][1] - q[1] - O[1]) < 0.5; });
    });
    if (!same) return null;
    var scr = function (P) { return P.map(function (q) { var p = svg.createSVGPoint(); p.x = q[0] + O[0]; p.y = q[1] + O[1]; p = p.matrixTransform(m); return [p.x, p.y]; }); };
    var byId = function (g, id) { return g.pieces.filter(function (p) { return p.id === id; })[0]; };
    var cores = cur.pieces.map(function (p) { return clipConvex(byId(gx, p.id).pts, byId(gy, p.id).pts); })
      .filter(function (P) { return P.length >= 3 && Math.abs(area2(P)) > 1; });
    /* bords de la pièce le long de son axe (mur et avant) : les mêmes pour toutes les jonctions */
    var longs = function (id) {
      var p = byId(gx, id), ax = p.axis, n = Math.hypot(ax[0], ax[1]) || 1, L = [];
      p.pts.forEach(function (a, i) {
        var b = p.pts[(i + 1) % p.pts.length], dx = b[0] - a[0], dy = b[1] - a[1], l = Math.hypot(dx, dy);
        if (l > 0.5 && Math.abs(dx * ax[1] - dy * ax[0]) / (l * n) < 0.02) L.push([a, [dx / l, dy / l]]);
      });
      return L.length === 2 ? L : null;
    };
    var lx = function (P, u, Q, v) { var den = u[0] * v[1] - u[1] * v[0]; if (Math.abs(den) < 1e-9) return null; var t = ((Q[0] - P[0]) * v[1] - (Q[1] - P[1]) * v[0]) / den; return [P[0] + t * u[0], P[1] + t * u[1]]; };
    var corners = [];
    (cur.between || []).forEach(function (pr) {
      var a = longs(pr[0]), b = longs(pr[1]); if (!a || !b) return;
      var q = [lx(a[0][0], a[0][1], b[0][0], b[0][1]), lx(a[0][0], a[0][1], b[1][0], b[1][1]), lx(a[1][0], a[1][1], b[1][0], b[1][1]), lx(a[1][0], a[1][1], b[0][0], b[0][1])];
      if (q.every(Boolean)) corners.push(q);
    });
    if (cores.length !== cur.pieces.length || corners.length !== (cur.between || []).length) return null;
    /* cases de chant : au milieu de chaque bord de pièce, qui dépend des jonctions ; toutes leurs places possibles */
    var mids = [], J = ['retour', 'barre', 'onglet'];
    J.forEach(function (a) { J.forEach(function (b) { J.forEach(function (c) {
      window.CP_geomG(Object.assign({}, s0, { top: a, mid: b, ret: c })).pieces.forEach(function (p) {
        p.pts.forEach(function (q, i) {
          var r = p.pts[(i + 1) % p.pts.length], mm = [(q[0] + r[0]) / 2, (q[1] + r[1]) / 2];
          if (!mids.some(function (x) { return Math.abs(x[0] - mm[0]) < 0.5 && Math.abs(x[1] - mm[1]) < 0.5; })) mids.push(mm);
        });
      });
    }); }); });
    cores = cores.map(scr); corners = corners.map(scr);
    return { cores: cores, corners: corners, all: cores.concat(corners), mids: scr(mids) };
  }
  function inPoly(P, x, y) {
    var c = false;
    for (var i = 0, j = P.length - 1; i < P.length; j = i++) {
      if (((P[i][1] > y) !== (P[j][1] > y)) && (x < (P[j][0] - P[i][0]) * (y - P[i][1]) / (P[j][1] - P[i][1]) + P[i][0])) c = !c;
    }
    return c;
  }
  function segDist(p, a, b) {
    var dx = b[0] - a[0], dy = b[1] - a[1], l2 = dx * dx + dy * dy, t = l2 ? Math.max(0, Math.min(1, ((p[0] - a[0]) * dx + (p[1] - a[1]) * dy) / l2)) : 0;
    return Math.hypot(p[0] - a[0] - t * dx, p[1] - a[1] - t * dy);
  }
  function segsCross(a, b, c, d) {
    var o = function (p, q, r) { return (q[0] - p[0]) * (r[1] - p[1]) - (q[1] - p[1]) * (r[0] - p[0]); };
    return o(a, b, c) * o(a, b, d) < 0 && o(c, d, a) * o(c, d, b) < 0;
  }
  function polyGap(r, P) {                                     /* écart entre un rectangle et un polygone (0 s'ils se touchent) */
    var C = [[r.left, r.top], [r.right, r.top], [r.right, r.bottom], [r.left, r.bottom]], i, j, best = Infinity;
    for (i = 0; i < 4; i++) if (inPoly(P, C[i][0], C[i][1])) return 0;
    for (i = 0; i < P.length; i++) if (P[i][0] >= r.left && P[i][0] <= r.right && P[i][1] >= r.top && P[i][1] <= r.bottom) return 0;
    for (i = 0; i < P.length; i++) {
      var a = P[i], b = P[(i + 1) % P.length];
      for (j = 0; j < 4; j++) { if (segsCross(a, b, C[j], C[(j + 1) % 4])) return 0; best = Math.min(best, segDist(C[j], a, b)); }
    }
    for (i = 0; i < P.length; i++) for (j = 0; j < 4; j++) best = Math.min(best, segDist(P[i], C[j], C[(j + 1) % 4]));
    return best;
  }
  function insideGap(r, P) {                                   /* rectangle entièrement dans le polygone : écart à son contour ; −1 sinon */
    var C = [[r.left, r.top], [r.right, r.top], [r.right, r.bottom], [r.left, r.bottom]], i, j, best = Infinity;
    for (i = 0; i < 4; i++) if (!inPoly(P, C[i][0], C[i][1])) return -1;
    for (i = 0; i < P.length; i++) {
      var a = P[i], b = P[(i + 1) % P.length];
      if (a[0] > r.left && a[0] < r.right && a[1] > r.top && a[1] < r.bottom) return -1;
      for (j = 0; j < 4; j++) { if (segsCross(a, b, C[j], C[(j + 1) % 4])) return -1; best = Math.min(best, segDist(C[j], a, b), segDist(a, C[j], C[(j + 1) % 4])); }
    }
    return best;
  }
  /* croisements des bords des pièces avec la droite « le long = a » (v : droite y = a, sinon droite x = a) */
  function crossings(polys, v, a) {
    var out = [];
    polys.forEach(function (P) {
      for (var i = 0; i < P.length; i++) {
        var p = P[i], q = P[(i + 1) % P.length], pa = v ? p[1] : p[0], qa = v ? q[1] : q[0];
        if (pa === qa || (pa - a) * (qa - a) > 0) continue;
        var pp = v ? p[0] : p[1], qp = v ? q[0] : q[1];
        out.push(pp + (a - pa) * (qp - pp) / (qa - pa));
      }
    });
    return out;
  }
  function overlap(a, b, m) { return a[0] < b[1] + m && b[0] < a[1] + m; }
  function gapR(a, b) { return Math.max(a.left - b.right, b.left - a.right, a.top - b.bottom, b.top - a.bottom); }
  function shiftR(r, dx, dy) { return { left: r.left + dx, right: r.right + dx, top: r.top + dy, bottom: r.bottom + dy }; }
  function addTranslate(el, dx, dy) {
    var t = String(el.style.translate || '').match(/-?[\d.]+/g) || [], x = Number(t[0] || 0) + dx, y = Number(t[1] || 0) + dy;
    el.style.translate = x + 'px ' + y + 'px';
  }
  /* une cote : son côté, le sens extérieur (sg) et, en u (coordonnée écran comptée vers l'extérieur), son trait
     noir et ses chiffres (S), sa flèche (T), son étiquette (P), le bord de pièce côté dessin (uE) et la limite
     extérieure (uF : pièce, ou cadre si frameLim) */
  function dimInfo(d, polys, frame, fixed) {
    var side = (d.className.match(/\bpos-(top|bottom|left|right)\b/) || [])[1]; if (!side) return null;
    var v = side === 'left' || side === 'right', sg = side === 'top' || side === 'left' ? -1 : 1;
    var nearU = function (r) { return sg > 0 ? (v ? r.left : r.top) : -(v ? r.right : r.bottom); };
    var farU = function (r) { return sg > 0 ? (v ? r.right : r.bottom) : -(v ? r.left : r.top); };
    var along = function (r) { return v ? [r.top, r.bottom] : [r.left, r.right]; };
    var o = { d: d, side: side, v: v, sg: sg, along: along };
    var sub = d.querySelector(':scope > .dim-subdivisions');
    if (sub) {
      var sr = sub.getBoundingClientRect(), S = { el: sub, u: sg * (v ? sr.left : sr.top) + (sg > 0 ? 1 : 0), a: along(sr), labels: [] };   /* bord extérieur du trait (1 px) */
      var marks = [].slice.call(sub.querySelectorAll('.subdivision-marker')).map(function (m) { return m.getBoundingClientRect(); })
        .filter(function (r) { return r.width > 0 || r.height > 0; }).concat(fixed);
      [].slice.call(sub.querySelectorAll('.subdivision-label')).forEach(function (l) {
        var r = textBox(l); if (!(r.width > 0 && r.height > 0)) return;
        var g = TXT_GAP, a = along(r), th = farU(r) - nearU(r);
        for (var pass = 0; pass < 2; pass++) marks.forEach(function (m) {   /* repère, case de chant, « 90° » au droit du chiffre : au-delà */
          var f = farU(m) - S.u + MIN_GAP;
          if (overlap(along(m), a, MIN_GAP) && nearU(m) - S.u < g + th + MIN_GAP && f > g && f <= TXT_MAX) g = f;
        });
        S.labels.push({ el: l, o: o, n: nearU(r), th: th, a: a, g: g });
      });
      if (S.labels.length) o.S = S;
    }
    var t = d.querySelector(':scope > .track-std'), tr = t && t.getBoundingClientRect();
    if (tr && (tr.width > 0 || tr.height > 0)) o.T = { el: t, u: sg * (v ? (tr.left + tr.right) / 2 : (tr.top + tr.bottom) / 2), a: along(tr) };
    var pl = o.T && !d.classList.contains('readonly') ? d.querySelector(':scope > .label') : null, pr = pl && pl.getBoundingClientRect();
    if (pr && pr.width > 0 && pr.height > 0) o.P = { el: pl, n: nearU(pr), w: farU(pr) - nearU(pr), a: along(pr) };
    if (!o.S && !o.T) return null;
    var ref = o.S ? o.S.u : o.T.u;
    o.span = o.S ? o.S.a : o.T.a; o.uE = -Infinity; o.uF = farU(frame) - 2; o.frameLim = true;
    for (var k = 0; k < 5; k++) {                                   /* rayons perpendiculaires, 5 points le long de la cote */
      crossings(polys, v, o.span[0] + 3 + (o.span[1] - o.span[0] - 6) * k / 4).forEach(function (c) {
        var u = sg * c;
        if (u < ref - 0.5) o.uE = Math.max(o.uE, u);
        else if (u > ref + 0.5 && u - MIN_GAP < o.uF) { o.uF = u - MIN_GAP; o.frameLim = false; }
      });
    }
    return o;
  }
  /* groupes : cotes d'un même côté dont les portées se recouvrent, appuyées sur le même bord de pièce */
  function dimGroups(infos) {
    var groups = [];
    infos.forEach(function (o) {
      var hit = groups.filter(function (G) {
        return G[0].side === o.side && G.some(function (x) { return overlap(x.span, o.span, 0) && (x.uE === o.uE || Math.abs(x.uE - o.uE) <= 40); });
      });
      var G = [o];
      hit.forEach(function (h) { G = G.concat(h); groups.splice(groups.indexOf(h), 1); });
      groups.push(G);
    });
    return groups;
  }
  /* empilement d'un groupe ; renvoie ce qui manque encore au cadre (px), 0 sinon */
  function stackGroup(G) {
    var v = G[0].v, sg = G[0].sg, labs = [];
    G.forEach(function (o) { if (o.S) o.S.labels.forEach(function (l) { labs.push({ l: l, f: o.S.u + l.g + l.th }); }); });
    if (!labs.length) return 0;
    G.forEach(function (o) {
      if (!o.T) return;
      var need = o.T.u, ends = [[o.T.a[0], o.T.a[0] + 6], [o.T.a[1] - 6, o.T.a[1]]];
      labs.forEach(function (x) {
        if (!overlap(x.l.a, o.T.a, MIN_GAP)) return;
        var head = ends.some(function (e) { return overlap(x.l.a, e, MIN_GAP); });
        need = Math.max(need, x.f + MIN_GAP + (head ? 6 : 0.75));
      });
      o.T.nu = need;
      if (o.P) {
        o.P.min = need + PILL_MIN;
        labs.forEach(function (x) { if (overlap(x.l.a, o.P.a, MIN_GAP)) o.P.min = Math.max(o.P.min, x.f + MIN_GAP); });
        o.P.nn = Math.max(need + o.P.n - o.T.u, o.P.min);
      }
    });
    var lim = G.reduce(function (a, o) { return o.uF < a.uF ? o : a; }, G[0]), uF = lim.uF;
    /*  au doigt, la zone de toucher d'une pastille déborde de 14 px ; le cadre la coupait (cote
       latérale à 16 px du bord de l'écran, zone de 38 px) : 6 px de plus à garder libres au-delà de la pastille (mesuré :
       il en manquait 3 à gauche, où l'écran coupe, et 5 à droite, où le cadre coupe)*/
    var touchPad = window.matchMedia && window.matchMedia('(pointer: coarse)').matches ? 6 : 0;
    var ext = function () {
      var m = -Infinity;
      labs.forEach(function (x) { m = Math.max(m, x.f); });
      G.forEach(function (o) {
        if (o.T) m = Math.max(m, (o.T.nu === undefined ? o.T.u : o.T.nu) + 6);
        if (o.P && o.P.nn !== undefined) m = Math.max(m, o.P.nn + o.P.w + touchPad);
      });
      return m;
    };
    var over = ext() - uF, m = 0;
    if (over > 0) G.forEach(function (o) { if (o.P && o.P.nn !== undefined) o.P.nn = Math.max(o.P.min, o.P.nn - over); });   /* 1. étiquette contre sa flèche */
    over = ext() - uF;
    if (over > 0) {                                                                                                          /* 2. le tout vers le dessin */
      var room = Infinity;
      G.forEach(function (o) {
        if (o.S) room = Math.min(room, o.S.u - (o.uE + LINE_MIN));
        if (o.T) room = Math.min(room, (o.T.nu === undefined ? o.T.u : o.T.nu) - (o.uE + LINE_MIN));
      });
      m = Math.max(0, Math.min(over, room));
      over -= m;
    }
    var mv = function (el, du) { if (Math.abs(du) > 0.05) el.style.translate = v ? (sg * du) + 'px 0px' : '0px ' + (sg * du) + 'px'; };
    G.forEach(function (o) {
      if (o.S) { mv(o.S.el, -m); o.S.labels.forEach(function (l) { mv(l.el, o.S.u + l.g - l.n); }); }
      if (o.T) mv(o.T.el, (o.T.nu === undefined ? o.T.u : o.T.nu) - m - o.T.u);
      if (o.P) mv(o.P.el, (o.P.nn === undefined ? o.P.n : o.P.nn) - m - o.P.n);
    });
    return over > 0.5 && lim.frameLim ? over : 0;                                                                            /* 3. au cadre de s'élargir */
  }
  function declutter(A) {
    /* étagère V2 (cp-etagere) : la vue de face place ses pastilles et ses boutons en pixels réels ; l'empilement des
       cotes d'un même côté les déplaçait (É2 posée sur l'étagère du dessus, « + Étagère » sous une pastille) */
    if (typeof window.CP_etagPieces === 'function') return;
    var q = function (s) { return [].slice.call(A.dims.querySelectorAll(s)); };
    q('.subdivision-label, .dim > .label, .dim > .track-std, .dim-subdivisions').forEach(function (e) { e.style.translate = ''; });
    q('.dim > .label').forEach(function (e) { e.style.transform = ''; });   /* étiquette couchée sur sa pièce au passage précédent */
    q('.subdivision-label').forEach(function (l) { l.style.background = ''; });
    var stG = null; try { stG = stableG(A); } catch (e) {}           /* G : pièces sans la part que la jonction déplace */
    var polys = stG ? stG.all : piecePolys(A), frame = A.dims.getBoundingClientRect();
    var fixed = q('.edge-checkbox-visual, .cp-bout-pv').concat(A.svg ? [].slice.call(A.svg.querySelectorAll('.inner-angle-overlay text')) : [])
      .map(function (e) { return e.classList && e.classList.contains('edge-checkbox-visual') ? carreVu(e) : e.getBoundingClientRect(); }).filter(function (r) { return r.width > 0 && r.height > 0; });
    var infos = q('.dim').map(function (d) { return dimInfo(d, polys, frame, fixed); }).filter(Boolean);
    if (!infos.length) return;
    /* 1. empilement, côté par côté */
    var over = { left: 0, right: 0, top: 0, bottom: 0 };
    dimGroups(infos).forEach(function (G) { over[G[0].side] = Math.max(over[G[0].side], stackGroup(G)); });
    var rep = A.__cpA059 = { over: over, fails: [] };
    /* 2. contrôle sur les positions obtenues */
    var obst = [], add = function (r, el, dm, cb) { obst.push({ r: r, el: el, dm: dm, cb: !!cb }); };
    q('.dim > .track-std').forEach(function (t) {
      var r = t.getBoundingClientRect(), dm = t.parentNode; if (!(r.width > 0 || r.height > 0)) return;
      add(r, t, dm);
      if (r.height > r.width) { var cx = (r.left + r.right) / 2; add({ left: cx - 6, right: cx + 6, top: r.top, bottom: r.top + 6 }, t, dm); add({ left: cx - 6, right: cx + 6, top: r.bottom - 6, bottom: r.bottom }, t, dm); }
      else { var cy = (r.top + r.bottom) / 2; add({ left: r.left, right: r.left + 6, top: cy - 6, bottom: cy + 6 }, t, dm); add({ left: r.right - 6, right: r.right, top: cy - 6, bottom: cy + 6 }, t, dm); }
    });
    q('.dim-subdivisions').forEach(function (s) {
      var r = s.getBoundingClientRect(); if (!(r.width > 0 || r.height > 0)) return;
      add(/subdiv-(left|right)/.test(s.className) ? { left: r.left, right: r.left + 1, top: r.top, bottom: r.bottom } : { left: r.left, right: r.right, top: r.top, bottom: r.top + 1 }, s, s.parentNode);
    });
    q('.subdivision-marker, .edge-checkbox-visual, .cp-bout-pv').forEach(function (e) {   /* pastille d'un bout libre (pierre) comprise */
      var r = e.getBoundingClientRect(); if (!(r.width > 0 && r.height > 0)) return;
      add(r, e, e.closest('.dim'), e.classList.contains('edge-checkbox-visual'));
      if (e.classList.contains('edge-checkbox-visual')) obst[obst.length - 1].rv = carreVu(e);   /* C4 : ce que voit un chiffre gris */
    });
    if (A.svg) [].slice.call(A.svg.querySelectorAll('.inner-angle-overlay text')).forEach(function (e) {   /* « 90° » des coins intérieurs */
      var r = e.getBoundingClientRect(); if (r.width > 0 && r.height > 0) add(r, e, null);
    });
    var pills = q('.dim:not(.readonly) > .label').filter(function (p) { var r = p.getBoundingClientRect(); return r.width > 0 && r.height > 0; });
    pills.forEach(function (p) { add(p.getBoundingClientRect(), p, p.parentNode); });
    var labs = [];
    infos.forEach(function (o) { if (o.S) o.S.labels.forEach(function (l) { labs.push(l); add(textBox(l.el), l.el, null); }); });
    var onPiece = function (r) { return polys.some(function (P) { return polyGap(r, P) < MIN_GAP; }); };
    var why = function (r, el, dm) {                               /* '' si la place est libre ; dm : cote dont les traits ne gênent pas (étiquette orange) */
      if (r.left < frame.left + 2 || r.right > frame.right - 2 || r.top < frame.top + 2 || r.bottom > frame.bottom - 2) return 'cadre';
      if (onPiece(r)) return 'pièce';
      var gris = !!(el && el.classList && el.classList.contains('subdivision-label'));
      for (var i = 0; i < obst.length; i++) { var x = obst[i], xr = gris && x.rv ? x.rv : x.r; if (x.el !== el && !(dm && x.dm === dm) && gapR(r, xr) < MIN_GAP) return (x.el.className && x.el.className.baseVal === undefined ? String(x.el.className).split(' ')[0] : 'svg') + ' ' + gapR(r, xr).toFixed(1); }
      return '';
    };
    var clear = function (r, el, dm) { return !why(r, el, dm); };
    var setR = function (el, r) { obst.forEach(function (x) { if (x.el === el) x.r = r; }); };
    /* étiquettes orange posées sur une pièce (P1, P3 de profondeur, dans les pièces) :
       1. la place libre hors des pièces la plus proche de leur flèche, à PILL_FAR px au plus ;
       2. arbitrage : sinon elle peut rester sur SA pièce, entière, à 4 px au moins de son
          contour (donc de toute jonction), des repères, cases de chant, boutons de coin, « 90° » et autres
          chiffres, fond opaque. Elle reste sur sa flèche et se couche au besoin (P1 à l'horizontale dans la
          barre du haut, P3 debout dans un montant) ;
       3. sinon la place libre hors des pièces la plus proche, plus loin (160 px) ; sinon elle reste où elle est.*/
    if (A.svg) [].slice.call(A.svg.querySelectorAll('rect.hit')).forEach(function (e) {   /* coins (repères verts) */
      var r = e.getBoundingClientRect(); if (r.width > 0 && r.height > 0) add(r, e, null);
    });
    /* G : chaque place possible d'une case de chant, quelle que soit la jonction (étiquettes P seulement) */
    var cbS = 15, cb0 = A.dims.querySelector('.edge-checkbox-visual'), cbR = cb0 && cb0.getBoundingClientRect();
    if (cbR && cbR.width > 0) cbS = Math.max(cbR.width, cbR.height);
    var vObst = stG ? stG.mids.map(function (q) { return { left: q[0] - cbS / 2, right: q[0] + cbS / 2, top: q[1] - cbS / 2, bottom: q[1] + cbS / 2 }; }) : [];
    var freeV = function (r, g) { return vObst.every(function (v) { return gapR(r, v) >= g; }); };
    /* G : place libre pour une étiquette P ou sa flèche (cadre, pièces, autres cotes) ; cases de chant à toutes leurs places */
    var freeG = function (r, el, dm, g) {
      if (r.left < frame.left + 2 || r.right > frame.right - 2 || r.top < frame.top + 2 || r.bottom > frame.bottom - 2) return false;
      if (polys.some(function (P) { return polyGap(r, P) < g; })) return false;
      for (var i = 0; i < obst.length; i++) { var x = obst[i]; if (x.cb || x.el === el || (dm && x.dm === dm)) continue; if (gapR(r, x.r) < g) return false; }
      return freeV(r, g);
    };
    var NEAR = 12;                                                  /* étiquette P : à 12 px au plus de sa flèche */
    /* G : la flèche et son étiquette ensemble hors de la pièce. La flèche glisse perpendiculairement à elle-même (elle
       garde la profondeur qu'elle mesure) jusqu'à la première place libre, l'étiquette contre elle. */
    var bandOf = function (ta) { return ta.height > ta.width ? { left: ta.left - 6, right: ta.right + 6, top: ta.top, bottom: ta.bottom } : { left: ta.left, right: ta.right, top: ta.top - 6, bottom: ta.bottom + 6 }; };
    var nearLabel = function (p, r1, ta) {                          /* place libre de l'étiquette, contre la flèche ta (2 à 12 px) */
      var band = bandOf(ta), c = [];
      for (var ex = -90; ex <= 90; ex += 2) for (var ey = -90; ey <= 90; ey += 2) {
        var rr = shiftR(r1, ex, ey), g1 = gapR(rr, ta), g2 = gapR(rr, band);
        if (g1 <= NEAR && g2 >= 2) c.push([ex, ey, g1 + 0.02 * Math.hypot(ex, ey)]);
      }
      c.sort(function (a, b) { return a[2] - b[2]; });
      for (var i = 0; i < c.length; i++) { var rr2 = shiftR(r1, c[i][0], c[i][1]); if (freeG(rr2, p, p.parentNode, MIN_GAP)) return [c[i][0], c[i][1], rr2]; }
      return null;
    };
    /* R129 (Romain, 27/10 : « le P4 doit être devant son trait d'axe ») : cote de profondeur du G hors des pièces (P4, dans
       l'ouverture du G) : l'étiquette à la hauteur du milieu de sa flèche, d'abord SUR elle comme P1 et P3 (la flèche passe
       dessous, ses pointes restent visibles), sinon contre elle (2 px de sa bande), du côté où le moteur l'a posée puis de
       l'autre ; sinon de cran en cran (2 px) le long de la flèche, sans dépasser ses bouts ; sinon nearLabel (étiquette sur une
       pièce : les règles d'en dessous ; à 375, G gauche 3 600 / 2 400 / 2 400 / 1 800, la flèche est entre deux pièces). nearLabel seul
       la plaçait au plus près de la flèche, donc près d'une pointe : à 1 440, en G 3 600 / 2 400 / 2 400 / 1 800, 86 px sous
       le milieu, sous le bout de la flèche ; sur la flèche, le chiffre gris « 600 » du retour prend la place */
    var horsMilieu = function (r, ta) {                              /* l'étiquette ne couvre pas, dans le sens de la flèche, son milieu */
      return ta.height > ta.width ? Math.abs((r.top + r.bottom) / 2 - (ta.top + ta.bottom) / 2) > (r.bottom - r.top) / 2 : Math.abs((r.left + r.right) / 2 - (ta.left + ta.right) / 2) > (r.right - r.left) / 2;
    };
    var surFleche = function (p, r, ta) {
      var v = ta.height > ta.width, mx = (ta.left + ta.right) / 2, my = (ta.top + ta.bottom) / 2, cx0 = (r.left + r.right) / 2, cy0 = (r.top + r.bottom) / 2;
      var len = v ? ta.height : ta.width, pl = v ? r.bottom - r.top : r.right - r.left, pw = v ? r.right - r.left : r.bottom - r.top;
      var jeu = Math.max(0, (len - pl) / 2);                                  /* flèche plus courte que l'étiquette (375) : contre elle, au milieu */
      var band = bandOf(ta), cote = v ? (cx0 < mx ? -1 : 1) : (cy0 < my ? -1 : 1);
      var travers = [['sur', 0], ['contre', cote], ['contre', -cote]].map(function (k) {     /* décalage en travers de la flèche */
        if (k[0] === 'sur') return 0;
        return v ? (k[1] < 0 ? band.left - 2 - pw / 2 - mx : band.right + 2 + pw / 2 - mx) : (k[1] < 0 ? band.top - 2 - pw / 2 - my : band.bottom + 2 + pw / 2 - my);
      });
      for (var s = 0; s <= jeu; s += 2) for (var sg = -1; sg <= 1; sg += 2) {
        for (var k = 0; k < travers.length; k++) {
          if (k === 0 && s > (len - pl) / 2 - 6) continue;                    /* sur la flèche : ses pointes restent visibles (6 px) */
          var cx = v ? mx + travers[k] : mx + sg * s, cy = v ? my + sg * s : my + travers[k], rr = shiftR(r, cx - cx0, cy - cy0);
          if (freeG(rr, p, p.parentNode, MIN_GAP)) return [cx - cx0, cy - cy0, rr];
        }
        if (!s) break;                                                       /* au milieu : un seul essai par place */
      }
      return null;
    };
    var moveOut = function (p, t, r, tr) {
      var v = tr.height > tr.width, best = null;
      for (var d = 2; d <= 240 && !best; d += 2) for (var sg = -1; sg <= 1 && !best; sg += 2) {
        var dx = v ? sg * d : 0, dy = v ? 0 : sg * d, ta = shiftR(tr, dx, dy);
        if (!freeG(bandOf(ta), t, p.parentNode, 4)) continue;
        var lb = nearLabel(p, shiftR(r, dx, dy), ta);
        if (lb) best = [dx, dy, ta, dx + lb[0], dy + lb[1], lb[2]];
      }
      if (!best) return false;
      addTranslate(t, best[0], best[1]); setR(t, best[2]); addTranslate(p, best[3], best[4]); setR(p, best[5]);
      return true;
    };
    var outside = function (p, r, tr, far) {
      var c = [];
      for (var dx = -160; dx <= 160; dx += 4) for (var dy = -160; dy <= 160; dy += 4) {
        var gt = Math.max(0, gapR(shiftR(r, dx, dy), tr));
        if (gt <= far) c.push([dx, dy, gt + 0.02 * Math.hypot(dx, dy)]);
      }
      c.sort(function (a, b) { return a[2] - b[2]; });
      for (var i = 0; i < c.length; i++) { var rr = shiftR(r, c[i][0], c[i][1]); if (clear(rr, p, p.parentNode) && freeV(rr, MIN_GAP)) return [c[i][0], c[i][1], rr]; }
      return null;
    };
    var inside = function (p, t, tr, near) {
      var v = tr.height > tr.width, mx = (tr.left + tr.right) / 2, my = (tr.top + tr.bottom) / 2;
      var P = (stG ? stG.cores : polys).filter(function (Q) { return inPoly(Q, mx, my); })[0]; if (!P) return null;   /* G : jamais dans la zone d'un coin */
      var heads = v ? [{ left: mx - 6, right: mx + 6, top: tr.top, bottom: tr.top + 6 }, { left: mx - 6, right: mx + 6, top: tr.bottom - 6, bottom: tr.bottom }]
        : [{ left: tr.left, right: tr.left + 6, top: my - 6, bottom: my + 6 }, { left: tr.right - 6, right: tr.right, top: my - 6, bottom: my + 6 }];
      var ok = function (r) {
        if (insideGap(r, P) < 4 || (near && gapR(r, tr) > near)) return false;
        for (var i = 0; i < obst.length; i++) { var x = obst[i]; if (x.el !== p && x.el !== t && !(stG && x.cb) && gapR(r, x.r) < 4) return false; }
        return freeV(r, 4) && !heads.some(function (h) { return gapR(r, h) < 4; });
      };
      var dimV = p.parentNode.classList.contains('v'), base = p.style.transform;
      var forms = [base, dimV ? 'translate(0,-50%)' : 'translate(-50%,0) rotate(-90deg)'];   /* telle quelle, puis couchée / debout */
      for (var f = 0; f < forms.length; f++) {
        p.style.transform = forms[f];
        var saved = p.style.translate; p.style.translate = '';
        var r0 = p.getBoundingClientRect(), cx0 = (r0.left + r0.right) / 2, cy0 = (r0.top + r0.bottom) / 2, best = null;
        var len = v ? tr.height : tr.width;
        for (var s = 0; s <= len / 2 && !best; s += 2) for (var sg = -1; sg <= 1 && !best; sg += 2) for (var o = 0; o <= 64 && !best; o += 4) for (var so = -1; so <= 1 && !best; so += 2) {
          var cx = v ? mx + so * o : mx + sg * s, cy = v ? my + sg * s : my + so * o, dx = cx - cx0, dy = cy - cy0, rr = shiftR(r0, dx, dy);
          if (ok(rr)) best = [dx, dy, rr];
          if (o === 0) so = 2;                                               /* décalage nul : un seul essai */
        }
        if (best) { p.style.translate = best[0] + 'px ' + best[1] + 'px'; return best[2]; }
        p.style.translate = saved; p.style.transform = base;
      }
      return null;
    };
    pills.forEach(function (p) {
      var r = p.getBoundingClientRect(), t = p.parentNode.querySelector(':scope > .track-std'), tr = t ? t.getBoundingClientRect() : r;
      /* G, flèche posée sur une pièce : l'étiquette sur la même pièce (part commune à toutes les jonctions), à 12 px
         au plus de sa flèche ; sinon la flèche et l'étiquette ensemble hors de la pièce. Jamais l'étiquette seule dehors. */
      if (stG && t && polys.some(function (P) { return inPoly(P, (tr.left + tr.right) / 2, (tr.top + tr.bottom) / 2); })) {
        var nom = 'étiquette « ' + p.textContent.trim() + ' »';
        var rg = inside(p, t, tr, NEAR);
        if (rg) { setR(p, rg); rep.fails.push(nom + ' sur sa pièce, contre sa flèche'); return; }
        if (moveOut(p, t, r, tr)) { rep.fails.push(nom + ' et sa flèche hors de la pièce'); return; }
        rep.fails.push(nom + ' : aucune place (règle d\'avant)');
      } else if (stG && t && /^P\d/.test(p.textContent.trim()) && (onPiece(r) || gapR(r, tr) > NEAR || horsMilieu(r, tr))) {   /* G, cote de profondeur hors des pièces : étiquette contre sa flèche */
        var sf = surFleche(p, r, tr);
        if (sf) { addTranslate(p, sf[0], sf[1]); setR(p, sf[2]); return; }
        if (!onPiece(r)) {                                                 /* sur une pièce : règles ci-dessous */
          if (gapR(r, tr) <= NEAR) return;                                 /* R129 : déjà contre sa flèche, sans place au milieu */
          var ln = nearLabel(p, r, tr);
          if (ln) { addTranslate(p, ln[0], ln[1]); setR(p, ln[2]); }
          else rep.fails.push('étiquette « ' + p.textContent.trim() + ' » loin de sa flèche (aucune place plus près)');
          return;
        }
      }
      if (!onPiece(r)) return;
      var b = outside(p, r, tr, PILL_FAR);
      if (b) { addTranslate(p, b[0], b[1]); setR(p, b[2]); return; }
      var ri = t && inside(p, t, tr);
      if (ri) { setR(p, ri); rep.fails.push('étiquette « ' + p.textContent.trim() + ' » sur sa pièce, entière (règle retenue)'); return; }
      b = outside(p, r, tr, 160);
      if (b) { addTranslate(p, b[0], b[1]); setR(p, b[2]); rep.fails.push('étiquette « ' + p.textContent.trim() + ' » loin de sa flèche'); return; }
      rep.fails.push('étiquette « ' + p.textContent.trim() + ' » laissée sur sa pièce');
    });
    /* chiffres encore gênés : le long de leur cote sans en sortir, jusqu'à 12 px de leur trait */
    labs.forEach(function (l) {
      var r = textBox(l.el); if (clear(r, l.el, null)) return;
      var o = l.o, a = o.along(r), c0 = (a[0] + a[1]) / 2, lo = o.S.a[0] - c0, hi = o.S.a[1] - c0, best = null;
      for (var s = 0; !best && s <= Math.max(-lo, hi); s += 2) {
        [s, -s].forEach(function (ds) {
          for (var g = l.g; !best && ds >= lo && ds <= hi && g <= TXT_MAX; g++) {
            var dx = o.v ? o.sg * (g - l.g) : ds, dy = o.v ? ds : o.sg * (g - l.g), rr = shiftR(r, dx, dy);
            if (clear(rr, l.el, null)) best = [dx, dy, rr];
          }
        });
      }
      if (best) { addTranslate(l.el, best[0], best[1]); setR(l.el, best[2]); }
      else if (!onPiece(r)) { rep.fails.push('fond sous « ' + l.el.textContent.trim() + ' » (' + why(r, l.el, null) + ')'); l.el.style.background = 'rgba(255,255,255,.9)'; }
      else rep.fails.push('chiffre « ' + l.el.textContent.trim() + ' » sur une pièce');
    });
    /* 3. cadre trop étroit (écran de 480 px ou moins) : marge du viewBox élargie, puis nouveau rendu */
    var need = Math.max(over.left, over.right);
    if (need > 0 && sideKey && !sidePending && (sideExtra[sideKey] || 0) < 60) {
      sideExtra[sideKey] = Math.min(60, (sideExtra[sideKey] || 0) + Math.ceil(need) + 1);
      sidePending = true;
      setTimeout(function () { sidePending = false; A.render(); }, 0);
    }
  }

  /* Forme en G : les 8 cotes de saisie n'affichent qu'un nombre -> nom visible.
     Mesuré dans les deux sens : les appels de renderG posent toujours haut,
     P haut, côté gauche, P, côté droit, P, retour, P retour (dans cet ordre à l'écran).
     Mêmes noms qu'en U : L2 à gauche, L3 à droite.*/
  var G_NAMES = ['L1', 'P1', 'L2', 'P2', 'L3', 'P3', 'L4', 'P4'];
  function nameG(A, fn) {
    var o = A.addDim, n = 0, names = G_NAMES;
    A.addDim = function () {
      var a = [].slice.call(arguments), opt = a[4] || {};
      if (opt.editable !== false && opt.txt && /^\d+$/.test(String(opt.txt).trim()) && n < names.length) {
        opt = Object.assign({}, opt, { txt: names[n++] + ' : ' + String(opt.txt).trim() }); a[4] = opt;
      }
      return o.apply(this, a);
    };
    try { return fn(); } finally { A.addDim = o; }
  }

  /*  sur un écran étroit, les cotes latérales (L2, L3…) sont posées dans la marge du
     dessin, devenue trop petite en px : leurs libellés sortent du cadre. Quand le dessin fait
     480 px de large ou moins et qu'il est limité par sa largeur, on élargit le cadre (viewBox)
     de SIDE_PX de chaque côté, au moment où le rendu le fixe, donc avant que cotes et cases
     soient placées. Les coordonnées du dessin ne changent pas.
      si l'empilement trait noir / chiffre / flèche / étiquette ne tient toujours pas, declutter
     ajoute ce qui manque (sideExtra, par largeur et cadre du moteur) et relance un rendu.*/
  var SIDE_PX = 22, sideExtra = {}, sideKey = null, sidePending = false;
  function withSideMargin(A, fn, args) {
    var svg = A.svg, w = svg ? svg.clientWidth : 0, h = svg ? svg.clientHeight : 0;
    sideKey = null;
    if (!svg || !(w > 0 && w <= 480) || typeof window.CP_etagPieces === 'function') return fn(A, args);   /* étagère : marges déjà en px */
    var had = Object.prototype.hasOwnProperty.call(svg, 'setAttribute'), prev = svg.setAttribute, done = false;
    svg.setAttribute = function (k, v) {
      if (k === 'viewBox' && !done) {
        done = true;
        var vb = String(v).split(/\s+/).map(Number);
        /*  plus de condition « limité par sa largeur » : le cadre (cp-trace, fitStage) prend la hauteur du
           dessin, qui se trouve alors juste à la limite ; limité par sa hauteur, la marge ne change rien*/
        if (vb.length === 4 && vb[2] > 0 && vb[3] > 0) {
          sideKey = w + '|' + v + '|' + (A.S && A.S.layout);
          var px = SIDE_PX + (sideExtra[sideKey] || 0), m = px * vb[2] / (w - 2 * px);
          v = (vb[0] - m) + ' ' + vb[1] + ' ' + (vb[2] + 2 * m) + ' ' + vb[3];
        }
      }
      return prev.call(this, k, v);
    };
    try { return fn(A, args); }
    finally { if (had) svg.setAttribute = prev; else delete svg.setAttribute; }
  }

  function wrap(A) {
    if (A.__cpA11yWrapped) return;
    A.__cpA11yWrapped = true;
    /* clé du coin sur la zone SVG (le moteur ne la garde que dans son gestionnaire de clic) */
    var oHit = A.addHit;
    A.addHit = function () {
      var r = oHit.apply(this, arguments), g = this.svg && this.svg.lastElementChild, hit = g && g.querySelector && g.querySelector('rect.hit');
      if (hit && arguments[4]) hit.setAttribute('data-cp-id', String(arguments[4]));
      return r;
    };
    /* coordonnées (repère du dessin) de chaque case de chant, pour la replacer ensuite */
    var oCb = A.addEdgeCheckbox;
    if (typeof oCb === 'function') A.addEdgeCheckbox = function (x, y) {
      var c = oCb.apply(this, arguments);
      if (c && c.style) c.__cpXY = [Number(x), Number(y)];
      return c;
    };
    if (typeof A.renderG === 'function') {
      var oG = A.renderG;
      A.renderG = function () { var that = this, args = arguments; return nameG(this, function () { return oG.apply(that, args); }); };
    }
    var oRender = A.render;
    A.render = function () {
      var before = identify(document.activeElement);
      var dlg = openDialog(), inDialog = !!(dlg && dlg.el.contains(document.activeElement));
      var popupOpen = document.activeElement && document.activeElement.closest && document.activeElement.closest('#edge-dims-popup, #edge-menu');
      var r = withSideMargin(this, function (that, args) { return oRender.apply(that, args); }, arguments);
      var self = this;
      try {
        enhance(this);
        var target = before || (popupOpen ? lastTrigger : null);
        if (target) focusBack(this, target);
      } catch (e) { console.warn('[cp-a11y]', e); }
      /* choix fait dans une fenêtre (finition, épaisseur…) : si elle s'est refermée, le focus
         revient au bouton qui l'a ouverte ; si elle reste ouverte, il y reste */
      if (inDialog) setTimeout(function () {
        var still = openPopup();
        if (still) { enhanceDialog(still); syncChecks(still); if (!still.contains(document.activeElement)) focusPopup(self); }
        else focusBack(self, lastTrigger);
      }, 0);
      return r;
    };
    document.addEventListener('keydown', onPopupKey, true);
    /* boutons qui ouvrent une fenêtre (jambages, évier, forme, finition, épaisseur) ;
       clic dans une fenêtre ouverte -> surveiller sa fermeture pour rendre le focus */
    document.addEventListener('click', function (e) {
      var o = openDialog();
      if (o && e.target && o.el.contains(e.target)) {
        watchClose(o.el);
        setTimeout(function () { if (openPopup() === o.el) enhanceDialog(o.el); }, 0);   /* bornes et option du moment */
        return;
      }
      var h = e.target && e.target.closest && e.target.closest('rect.hit');       /* clic souris sur un coin */
      if (h && h.getAttribute('data-cp-id')) {
        if (e.isTrusted) { lastTrigger = { t: 'hit', k: h.getAttribute('data-cp-id') }; focusPopup(getApp()); }
        return;
      }
      var b = e.target && e.target.closest && e.target.closest(OPENERS);
      if (!b) return;
      lastTrigger = identify(b);
      focusPopup(getApp());
    }, true);
    /* option choisie dans le menu d'un coin : le moteur peut ouvrir ensuite la fenêtre de
       réglage (rayon, biseau, encoche) -> le focus y entre ; sinon il revient sur le coin */
    document.addEventListener('click', function (e) {
      if (!(e.target && e.target.closest && e.target.closest('#edge-menu .em-opt'))) return;
      setTimeout(function () {
        var A2 = getApp(), pop = document.getElementById('edge-dims-popup');
        if (pop && !pop.classList.contains('hidden')) focusPopup(A2); else focusBack(A2, lastTrigger);
      }, 0);
    }, true);
    var t = null;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(reposition, 120); });
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function () { reposition(); });
      ro.observe(A.svg);
      var tb = document.getElementById('stage-toolbar'); if (tb) ro.observe(tb);   /* sa hauteur déplace le dessin */
    }
    document.addEventListener('fullscreenchange', function () { setTimeout(reposition, 200); });
    edgeClose(A);
    fsFocus();
    fsSync();
    stageNoScroll();
    fsRefusal();
    qtyGuard();
    try { A.render(); } catch (e) { console.warn('[cp-a11y]', e); }
  }

  /*  le menu d'usinage d'un coin (#edge-menu, moteur) n'avait aucun bouton de fermeture ; au doigt,
     sans Échap, il fallait deviner qu'il faut toucher à côté. ✕ « Fermer » en haut à droite (44 × 44 au doigt) :
     fermeture du moteur (closeMenu), focus rendu au coin.*/
  function edgeClose(A) {
    var m = document.getElementById('edge-menu'); if (!m || m.querySelector('.cp-em-x')) return;
    if (!document.getElementById('cp-em-x-css')) {
      var st = document.createElement('style'); st.id = 'cp-em-x-css';
      /*  PAS de position ici. Le menu est en position:fixed (moteur,
         configurator-custom l. 406), placé près du coin et borné à l'écran (configurator-main, RÉV.20) ; un
         #edge-menu{position:relative} le remettait dans le flux, sous le dessin, coupé par #stage, et le focus
         faisait défiler #stage (dessin sorti par le haut). Le ✕ en absolu se cale sur le menu fixe.*/
      st.textContent = '#edge-menu .em-title{padding-right:40px}' +
        '#edge-menu .cp-em-x{position:absolute;top:4px;right:4px;width:32px;height:32px;display:flex;align-items:center;justify-content:center;' +
        'border:0;border-radius:6px;background:transparent;color:#374151;font-size:18px;line-height:1;cursor:pointer}' +
        '#edge-menu .cp-em-x:hover{background:rgba(0,0,0,.06)}#edge-menu .cp-em-x:focus-visible{outline:2px solid #80602f;outline-offset:1px}' +
        '@media (max-width:768px),(pointer:coarse){#edge-menu .cp-em-x{width:44px;height:44px;top:0;right:0}#edge-menu .em-title{padding-right:48px}}';
      document.head.appendChild(st);
    }
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'cp-em-x'; x.setAttribute('aria-label', 'Fermer'); x.innerHTML = '<span aria-hidden="true">✕</span>';
    x.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var B = getApp(); try { if (B && typeof B.closeMenu === 'function') B.closeMenu(); else m.classList.add('hidden'); } catch (err) {}
      try { focusBack(B, lastTrigger); } catch (err) {}
    });
    m.insertBefore(x, m.firstChild);
  }

  /*  film trame par trame.
     À l'entrée, le plein écran devenait actif une trame AVANT la mise en page du plein écran (classe cfgfs-on,
     custom-configV2) : le moteur la pose au setTimeout qui suit « fullscreenchange ». Pendant cette trame, le dessin
     prenait tout l'écran (haut 10, hauteur 825 à 1 440), puis sautait sous la barre (haut 144, hauteur 711).
     Le moteur surveille aussi les classes de #stage (MutationObserver → sync, en microtâche) : en touchant une classe
     neutre PENDANT l'événement, sa mise en page se fait dans la même trame, avant qu'elle soit peinte. Même chose à
     la sortie. Aucune règle de mise en page n'est changée.
     Entrée, suite : le moteur pose aussi is-fullscreen dès le clic (rAF, configurator-main), 60 à
     90 ms AVANT que le navigateur passe en plein écran. La règle .stage.is-fullscreen (configurator-custom.css :
     padding-top 10 px, hauteur 100 %, flex) s'appliquait donc hors plein écran : dessin remonté de 35 px et agrandi
     d'autant (de 70 px à 375), pendant 3 ou 4 trames. La classe est retenue jusqu'au vrai plein écran, puis rendue
     dans l'événement même, avec la mise en page du moteur. Repli mobile (is-fullscreen-mobile) : non concerné.
     Fondu : fs-preparing / fs-exiting passaient le
     cadre à l'opacité 0 puis fs-ready le ramenait (clignement de 0,4 s), pour masquer un saut qui n'existe plus.
     Repli iPhone : l'animation du moteur fullscreenSlideIn (is-fullscreen-mobile) anime aussi l'opacité ;
     une fois fs-preparing levé, elle reprenait la main (1 → 0,86 → 1 en 150 ms). Opacité tenue à 1, zoom du moteur gardé.*/
  function fsSync() {
    var stage = document.getElementById('stage'); if (!stage) return;
    if (!document.getElementById('cp-fs-nofade')) {
      var st = document.createElement('style'); st.id = 'cp-fs-nofade';
      st.textContent = '#stage.fs-preparing,#stage.fs-exiting{opacity:1!important;transition:none!important}#stage.is-fullscreen-mobile{opacity:1!important}';
      document.head.appendChild(st);
    }
    var tick = function () { stage.classList.toggle('cp-fs-tick'); stage.classList.toggle('cp-fs-tick'); };
    var fsEl = function () { return document.fullscreenElement || document.webkitFullscreenElement || null; };
    var held = false;
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        if (stage.classList.contains('is-fullscreen') && fsEl() !== stage && !stage.classList.contains('is-fullscreen-mobile')) {
          held = true; stage.classList.remove('is-fullscreen');
        }
      }).observe(stage, { attributes: true, attributeFilter: ['class'] });
    }
    var onFs = function () {
      if (fsEl() === stage) { if (held) { held = false; stage.classList.add('is-fullscreen'); } }
      else held = false;
      tick();
    };
    ['fullscreenchange', 'webkitfullscreenchange'].forEach(function (ev) { document.addEventListener(ev, onFs, true); });
  }

  /*  plein écran REFUSÉ par le navigateur (clic sans geste utilisateur, navigateur intégré à
     une appli : « Permissions check failed »). Le moteur attendait un fullscreenchange qui ne venait jamais : bouton
     « Quitter », #stage en fs-preparing, 2e clic et Échap sans effet (isAnimating resté vrai). Au refus
     (fullscreenerror) : un fullscreenchange rejoue la sortie normale du moteur (bouton, classes, isAnimating), puis le
     repli CSS du moteur (celui de l'iPhone : is-fullscreen-mobile, que custom-configV2 suit par sa classe) prend le
     relais. « Quitter » et Échap en sortent ; les clics suivants vont directement au repli.*/
  function fsRefusal() {
    var stage = document.getElementById('stage'), btn = document.getElementById('btn-fullscreen');
    if (!stage || !btn || stage.__cpFsRef) return;
    stage.__cpFsRef = true;
    var on = false, refused = false;
    var label = function (t) { var s = btn.querySelector('span'); if (s) s.textContent = t; };
    var redraw = function () { setTimeout(function () { var B = getApp(); try { if (B && B.render) B.render(); } catch (e) {} }, 60); };
    var enter = function () {
      on = true;
      stage.classList.remove('fs-preparing', 'fs-exiting'); stage.classList.add('fs-ready');
      stage.classList.add('is-fullscreen-mobile'); document.body.classList.add('fullscreen-mobile-active');
      label('Quitter');
      try { window.scrollTo(0, 0); } catch (e) {}
      redraw();
    };
    var leave = function () {
      on = false;
      stage.classList.remove('is-fullscreen-mobile'); document.body.classList.remove('fullscreen-mobile-active');
      label('Plein écran');
      redraw();
      try { btn.focus({ preventScroll: true }); } catch (e) {}
    };
    ['fullscreenerror', 'webkitfullscreenerror'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        if (on || refused) return;
        refused = true;
        try { document.dispatchEvent(new Event('fullscreenchange')); } catch (e) {}
        setTimeout(enter, 200);                                  /* après la remise à zéro du moteur (140 ms) */
      });
    });
    btn.addEventListener('click', function (e) {
      if (!on && !refused) return;                               /* cas normal : le moteur */
      e.preventDefault(); e.stopImmediatePropagation();
      if (on) leave(); else enter();
    }, true);
    document.addEventListener('keydown', function (e) {
      if (on && e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); leave(); }
    }, true);
  }

  /*  champ Quantité. 0, −3 et 2,5 étaient acceptés sans message : le moteur commandait 1 (ou 2)
     en laissant « 0 » affiché (_qte_commande = 1), et rien ne bornait le haut (1 000 accepté). Entier de 1 à QTY_MAX,
     ramené avec un message quand le champ perd le focus (donc avant tout clic sur « Ajouter au panier »).*/
  var QTY_MAX = 99;
  function qtyGuard() {
    var i = document.getElementById('qty-input'); if (!i || i.__cpQty) return;
    i.__cpQty = true;
    i.setAttribute('min', '1'); i.setAttribute('max', String(QTY_MAX)); i.setAttribute('step', '1'); i.setAttribute('inputmode', 'numeric');
    var fix = function () {
      var raw = String(i.value).trim().replace(',', '.'), n = Number(raw), v = Math.floor(n), msg = '';
      /* champ numérique : « 2,5 » ou du texte y donnent une valeur vide (validity.badInput), illisible ici */
      if (i.validity && i.validity.badInput) { v = 1; msg = 'Quantité : un nombre entier, de 1 à ' + QTY_MAX + ' ; ramenée à 1.'; }
      else if (raw === '' || !isFinite(n) || n < 1) { v = 1; msg = 'Quantité ramenée à 1 (minimum).'; }
      else if (v > QTY_MAX) { v = QTY_MAX; msg = 'Quantité ramenée à ' + QTY_MAX + ' : au-delà, écrivez-nous.'; }   /* lot « messages 2 », N39 */
      else if (v !== n) msg = 'Quantité entière : ramenée à ' + v + '.';
      if (String(v) !== String(i.value)) { i.value = String(v); i.dispatchEvent(new Event('input', { bubbles: true })); }
      if (msg && window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(msg, 'info', 5000);
    };
    i.addEventListener('change', fix);
    i.addEventListener('blur', fix);
  }

  /*  #stage (overflow:hidden) ne doit jamais défiler : un focus ou un scrollIntoView sur un élément
     qui le dépasse (fenêtre, champ) le faisait défiler et le dessin sortait du cadre (scrollTop 667). Remis à 0 au
     premier événement de défilement, avant la peinture. Repli iPhone (is-fullscreen-mobile, overflow:auto) : libre.*/
  function stageNoScroll() {
    var stage = document.getElementById('stage'); if (!stage || stage.__cpNoScroll) return;
    stage.__cpNoScroll = true;
    stage.addEventListener('scroll', function () {
      if (stage.classList.contains('is-fullscreen-mobile')) return;
      if (stage.scrollTop || stage.scrollLeft) { stage.scrollTop = 0; stage.scrollLeft = 0; }
    }, { passive: true });
  }

  /*  en entrant en plein écran, le focus tombait sur la page (BODY) ; en sortant, il n'était pas rendu
     au bouton. Il va sur le bouton du plein écran (#btn-fullscreen, « Quitter » puis « Plein écran »), sauf si le
     client a déjà placé le focus dans le cadre.*/
  function fsFocus() {
    var stage = document.getElementById('stage'); if (!stage || typeof MutationObserver !== 'function') return;
    var isFs = function () { return stage.classList.contains('is-fullscreen') || stage.classList.contains('cfgfs-on') || stage.classList.contains('is-fullscreen-mobile'); };
    var was = isFs(), t = null;
    var settle = function () {
      var now = isFs(); if (now === was) return; was = now;
      clearTimeout(t); t = setTimeout(function () {
        var b = document.getElementById('btn-fullscreen'), a = document.activeElement;
        if (!b || !b.getClientRects().length) return;
        if (now && a && a !== document.body && stage.contains(a) && a !== b) return;
        try { b.focus({ preventScroll: true }); } catch (e) { b.focus(); }
      }, 250);
    };
    new MutationObserver(settle).observe(stage, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('fullscreenchange', settle);
  }

  var tries = 0;
  var timer = setInterval(function () {
    var A = getApp();
    if (A && A.S && A.svg && A.dims && typeof A.render === 'function' && typeof A.addHit === 'function') { clearInterval(timer); wrap(A); }
    else if (++tries > 400) clearInterval(timer);
  }, 50);

  /*  la ligne d'aide est l'élément LCP de la fiche ; elle attendait le moteur (window.load,
     après toutes les images). Posée dès la lecture de la page (fichier différé), à sa place finale (cp-trace)*/
  function earlyHelp() {
    if (!document.getElementById('stage')) return;
    injectCss(); helpLine();
    if (typeof window.CP_placeHelp === 'function') window.CP_placeHelp();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', earlyHelp); else earlyHelp();
})();
